/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AIErrorCategory */
export enum AIErrorCategory {
    ProviderError = 'provider_error',
    RequestError = 'request_error',
    RetryableError = 'retryable_error',
}

/** AllUserNotificationCreate */
export interface AllUserNotificationCreate {
    /** User Uuid */
    user_uuid?: null
    /**
     * Тип уведомления.
     * @default "GLOBAL"
     */
    notification_type?: NotificationType
    /**
     * Event Id
     * ID события (notification_events.id).
     */
    event_id: number
    /**
     * Message
     * Текст уведомления.
     */
    message: string
    /** Action Url */
    action_url?: string | null
    /** Action Text */
    action_text?: string | null
    /** Payload */
    payload?: null
    /**
     * Is Read
     * Статус прочтения.
     * @default false
     */
    is_read?: boolean
}

/** AppliedPromocodeDTO */
export interface AppliedPromocodeDTO {
    /** Id */
    id: number | null
    /** Promocode Id */
    promocode_id: number
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Applied Dt
     * @format date-time
     */
    applied_dt: string
}

/** ApplyPromocodeModel */
export interface ApplyPromocodeModel {
    /** Code */
    code: string
}

/** AssistantAvailableEnum */
export enum AssistantAvailableEnum {
    FREE = 'FREE',
    PAID = 'PAID',
    UNAVAILABLE = 'UNAVAILABLE',
}

/** AssistantCategoryDTO */
export interface AssistantCategoryDTO {
    /** Id */
    id: number
    /** Name */
    name: string
}

/** AssistantCategoryListOutputDTO */
export interface AssistantCategoryListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: AssistantCategoryDTO[]
}

/** AssistantDTO */
export interface AssistantDTO {
    /** Id */
    id: number
    /** User Uuid */
    user_uuid: string | null
    /** Name */
    name: string
    /** Description */
    description: string
    /** Full Description */
    full_description: string
    /** Example */
    example: string
    /** Based On */
    based_on: string
    /** Disclamer */
    disclamer: string
    /** Header Text */
    header_text: string
    /** Greeting Message */
    greeting_message: string
    /** User Actions */
    user_actions: string[]
    category: AssistantCategoryDTO | null
    /** Tags */
    tags: string[]
    privacy: AssistantPrivacy
    /** Agent */
    agent: string
    /** Is Popular */
    is_popular: boolean | null
    /** Params */
    params: (BoolParam | RangeParam | SelectOneParam | SelectMultipleParam | TextParam)[]
    /** Popularity */
    popularity: number
    available: AssistantAvailableEnum
    /** Price */
    price: number
    /** Available On Tariffs */
    available_on_tariffs: string[]
    /**
     * Is Protected
     * @default false
     */
    is_protected?: boolean
    /**
     * Is Favorite
     * @default false
     */
    is_favorite?: boolean
}

/** AssistantFiltersOutputDTO */
export interface AssistantFiltersOutputDTO {
    /** Available Categories */
    available_categories: AssistantCategoryDTO[]
}

/** AssistantFreePeriod */
export interface AssistantFreePeriod {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Assistant Id */
    assistant_id: number
    /** Assistant Name */
    assistant_name: string
    /** Auto Renew */
    auto_renew: boolean
    /**
     * Start At
     * Начало бесплатного периода
     * @format date-time
     */
    start_at: string
    /**
     * End At
     * Окончание бесплатного периода
     * @format date-time
     */
    end_at: string
    /** Is Free */
    is_free: boolean
    /** Id */
    id: number
    /** Is Active */
    is_active: boolean
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
}

/** AssistantFreePeriodUserInfoIsAvailable */
export interface AssistantFreePeriodUserInfoIsAvailable {
    /** Is Available */
    is_available: boolean
}

/** AssistantListOutputDTO */
export interface AssistantListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: AssistantShortDTO[]
}

/** AssistantPrivacy */
export enum AssistantPrivacy {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
    SYSTEM = 'SYSTEM',
}

/** AssistantShortDTO */
export interface AssistantShortDTO {
    /** Id */
    id: number
    /** User Uuid */
    user_uuid: string | null
    /** Name */
    name: string
    /** Description */
    description: string
    /** Full Description */
    full_description: string
    /** Example */
    example: string
    /** Based On */
    based_on: string
    /** Disclamer */
    disclamer: string
    /** Header Text */
    header_text: string
    /** Greeting Message */
    greeting_message: string
    /** User Actions */
    user_actions: string[]
    category: AssistantCategoryDTO | null
    /** Tags */
    tags: string[]
    privacy: AssistantPrivacy
    /** Is Popular */
    is_popular: boolean | null
    /** Agent */
    agent: string
    /** Popularity */
    popularity: number
    available: AssistantAvailableEnum
    /** Price */
    price: number
    /** Available On Tariffs */
    available_on_tariffs: string[]
    /**
     * Is Restricted
     * @default false
     */
    is_restricted?: boolean
    /**
     * Is Protected
     * @default false
     */
    is_protected?: boolean
    /**
     * Is Favorite
     * @default false
     */
    is_favorite?: boolean
}

/** AssistantSortingField */
export enum AssistantSortingField {
    Name = 'name',
    Price = 'price',
    Id = 'id',
    Popularity = 'popularity',
}

/** AssistantSubscription */
export interface AssistantSubscription {
    /** Id */
    id: number
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Assistant Id */
    assistant_id: number
    /** Assistant Name */
    assistant_name: string
    /**
     * Start At
     * @format date-time
     */
    start_at: string
    /**
     * End At
     * @format date-time
     */
    end_at: string
    /** Auto Renew */
    auto_renew: boolean
    /** Is Active */
    is_active: boolean
    /** Is Free */
    is_free: boolean
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
}

/** AuthenticatedUserDTO */
export interface AuthenticatedUserDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Is Active */
    is_active: boolean
    /** Rag Size Mb */
    rag_size_mb?: number | null
    /**
     * Restricted
     * @default false
     */
    restricted?: boolean
    /**
     * Is New
     * @default false
     */
    is_new?: boolean
    /**
     * Is Temp
     * @default false
     */
    is_temp?: boolean
}

/** AutoRenewStatusEnum */
export enum AutoRenewStatusEnum {
    PENDING = 'PENDING',
    RETRYING = 'RETRYING',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
}

/** BalanceIncreaseDTO */
export interface BalanceIncreaseDTO {
    /** Id */
    id: number | null
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    increase_type: IncreaseType
    /** Balance Charge */
    balance_charge: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Invoice Id */
    invoice_id?: string | null
    /** Batch Uuid */
    batch_uuid?: string | null
    /**
     * Is Service
     * @default false
     */
    is_service?: boolean
    /** Description */
    description?: string | null
    /** Data */
    data?: Record<string, any> | null
}

/** BalanceIncreaseOutputDTO */
export interface BalanceIncreaseOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: BalanceIncreaseDTO[]
}

/** Body_create_reply_api_v1_collaboration_app_reply_post */
export interface BodyCreateReplyApiV1CollaborationAppReplyPost {
    /** Thread Id */
    thread_id?: number | null
    /** Text */
    text?: string | null
    /** Image Url */
    image_url?: string | null
    /** Voice Url */
    voice_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
    /** Contexts */
    contexts: string[]
    /** Agent */
    agent?: string | null
    /** Files */
    files?: string[] | null
    /**
     * Regenerate
     * @default false
     */
    regenerate?: boolean
    /** Parental Reply Id */
    parental_reply_id?: number | null
}

/** Body_create_thread_api_v1_collaboration_app_thread_post */
export interface BodyCreateThreadApiV1CollaborationAppThreadPost {
    /** Assistant Id */
    assistant_id?: number | null
    /** Workplace Id */
    workplace_id?: string | null
    /** Rag Enabled */
    rag_enabled?: boolean | null
    /** Voice Answer */
    voice_answer?: boolean | null
    /** Deep Research Enabled */
    deep_research_enabled?: boolean | null
    /** Context */
    context?: string | null
    /** Name */
    name: string
    /** Memory Message Count */
    memory_message_count?: number | null
    /** Agent */
    agent: string
    /** Params */
    params?: ThreadModelParamDTO[] | null
    /** Additional Contexts */
    additional_contexts?: ThreadAdditionalContextDTO[] | null
    /** Llm Tools */
    llm_tools?: ThreadLLMToolDTO[] | null
    /** Speech Voice */
    speech_voice?: string | null
    /** Voice Speed */
    voice_speed?: number | null
}

/** Body_imagine_api_v1_img_imagine_post */
export interface BodyImagineApiV1ImgImaginePost {
    model_slug: ModelSlug
    /** Prompt */
    prompt: string
    /** Parameters */
    parameters: Record<string, any>
}

/** Body_rate_reply_api_v1_collaboration_app_reply__reply_id__rate_post */
export interface BodyRateReplyApiV1CollaborationAppReplyReplyIdRatePost {
    /** Score */
    score?: number | null
    /** Description */
    description?: string | null
}

/** Body_reply_cost_post_api_v1_collaboration_app_reply_cost_post */
export interface BodyReplyCostPostApiV1CollaborationAppReplyCostPost {
    /** Thread Id */
    thread_id?: number | null
    /** Assistant Id */
    assistant_id?: number | null
    model_slug?: ModelSlug | null
    /** Reply Content */
    reply_content?: string | null
    /**
     * Web Search Used
     * @default false
     */
    web_search_used?: boolean | null
    /**
     * Rag Enabled
     * @default true
     */
    rag_enabled?: boolean | null
    /**
     * Voice Answer
     * @default false
     */
    voice_answer?: boolean | null
    /**
     * Memory Message Count
     * @default 3
     */
    memory_message_count?: number | null
}

/** Body_reroll_api_v1_img_reroll_post */
export interface BodyRerollApiV1ImgRerollPost {
    model_slug: ModelSlug
    /** Generation Task Id */
    generation_task_id: string
    /** Parameters */
    parameters: Record<string, any>
}

/** Body_user_login_api_v1_auth_login_post */
export interface BodyUserLoginApiV1AuthLoginPost {
    /**
     * Email
     * @format email
     */
    email: string
    /** Password */
    password: string
}

/** Body_verify_user_email_complete_api_v1_auth_user_email_verify_complete_post */
export interface BodyVerifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePost {
    /** Email Verify Id */
    email_verify_id: number
    /** Code */
    code: string
}

/** Body_workplace_update_api_v1_collaboration_app_workplace__workplace_id__patch */
export interface BodyWorkplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatch {
    /** Title */
    title?: string | null
    /** Context */
    context?: string | null
    /** Is Protected */
    is_protected?: boolean | null
    settings_model?: WorkplaceSettingsModel | null
}

/** BoolParam */
export interface BoolParam {
    /** Name */
    name: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Default */
    default: boolean
    /** @default "BOOL" */
    param_type?: ParamType
}

/** Country */
export enum Country {
    ValueObjectObject = '[object Object]',
    ValueObjectObject1 = '[object Object]',
    ValueObjectObject2 = '[object Object]',
    ValueObjectObject3 = '[object Object]',
    ValueObjectObject4 = '[object Object]',
    ValueObjectObject5 = '[object Object]',
    ValueObjectObject6 = '[object Object]',
    ValueObjectObject7 = '[object Object]',
    ValueObjectObject8 = '[object Object]',
    ValueObjectObject9 = '[object Object]',
    ValueObjectObject10 = '[object Object]',
    ValueObjectObject11 = '[object Object]',
    ValueObjectObject12 = '[object Object]',
    ValueObjectObject13 = '[object Object]',
    ValueObjectObject14 = '[object Object]',
    ValueObjectObject15 = '[object Object]',
    ValueObjectObject16 = '[object Object]',
    ValueObjectObject17 = '[object Object]',
    ValueObjectObject18 = '[object Object]',
    ValueObjectObject19 = '[object Object]',
    ValueObjectObject20 = '[object Object]',
    ValueObjectObject21 = '[object Object]',
    ValueObjectObject22 = '[object Object]',
    ValueObjectObject23 = '[object Object]',
    ValueObjectObject24 = '[object Object]',
    ValueObjectObject25 = '[object Object]',
    ValueObjectObject26 = '[object Object]',
    ValueObjectObject27 = '[object Object]',
    ValueObjectObject28 = '[object Object]',
    ValueObjectObject29 = '[object Object]',
    ValueObjectObject30 = '[object Object]',
    ValueObjectObject31 = '[object Object]',
    ValueObjectObject32 = '[object Object]',
    ValueObjectObject33 = '[object Object]',
    ValueObjectObject34 = '[object Object]',
    ValueObjectObject35 = '[object Object]',
    ValueObjectObject36 = '[object Object]',
    ValueObjectObject37 = '[object Object]',
    ValueObjectObject38 = '[object Object]',
    ValueObjectObject39 = '[object Object]',
    ValueObjectObject40 = '[object Object]',
    ValueObjectObject41 = '[object Object]',
    ValueObjectObject42 = '[object Object]',
    ValueObjectObject43 = '[object Object]',
    ValueObjectObject44 = '[object Object]',
    ValueObjectObject45 = '[object Object]',
    ValueObjectObject46 = '[object Object]',
    ValueObjectObject47 = '[object Object]',
    ValueObjectObject48 = '[object Object]',
    ValueObjectObject49 = '[object Object]',
    ValueObjectObject50 = '[object Object]',
    ValueObjectObject51 = '[object Object]',
    ValueObjectObject52 = '[object Object]',
    ValueObjectObject53 = '[object Object]',
    ValueObjectObject54 = '[object Object]',
    ValueObjectObject55 = '[object Object]',
    ValueObjectObject56 = '[object Object]',
    ValueObjectObject57 = '[object Object]',
    ValueObjectObject58 = '[object Object]',
    ValueObjectObject59 = '[object Object]',
    ValueObjectObject60 = '[object Object]',
    ValueObjectObject61 = '[object Object]',
    ValueObjectObject62 = '[object Object]',
    ValueObjectObject63 = '[object Object]',
    ValueObjectObject64 = '[object Object]',
    ValueObjectObject65 = '[object Object]',
    ValueObjectObject66 = '[object Object]',
    ValueObjectObject67 = '[object Object]',
    ValueObjectObject68 = '[object Object]',
    ValueObjectObject69 = '[object Object]',
    ValueObjectObject70 = '[object Object]',
    ValueObjectObject71 = '[object Object]',
    ValueObjectObject72 = '[object Object]',
    ValueObjectObject73 = '[object Object]',
    ValueObjectObject74 = '[object Object]',
    ValueObjectObject75 = '[object Object]',
    ValueObjectObject76 = '[object Object]',
    ValueObjectObject77 = '[object Object]',
    ValueObjectObject78 = '[object Object]',
    ValueObjectObject79 = '[object Object]',
    ValueObjectObject80 = '[object Object]',
    ValueObjectObject81 = '[object Object]',
    ValueObjectObject82 = '[object Object]',
    ValueObjectObject83 = '[object Object]',
    ValueObjectObject84 = '[object Object]',
    ValueObjectObject85 = '[object Object]',
    ValueObjectObject86 = '[object Object]',
    ValueObjectObject87 = '[object Object]',
    ValueObjectObject88 = '[object Object]',
    ValueObjectObject89 = '[object Object]',
    ValueObjectObject90 = '[object Object]',
    ValueObjectObject91 = '[object Object]',
    ValueObjectObject92 = '[object Object]',
    ValueObjectObject93 = '[object Object]',
    ValueObjectObject94 = '[object Object]',
    ValueObjectObject95 = '[object Object]',
    ValueObjectObject96 = '[object Object]',
    ValueObjectObject97 = '[object Object]',
    ValueObjectObject98 = '[object Object]',
    ValueObjectObject99 = '[object Object]',
    ValueObjectObject100 = '[object Object]',
    ValueObjectObject101 = '[object Object]',
    ValueObjectObject102 = '[object Object]',
    ValueObjectObject103 = '[object Object]',
    ValueObjectObject104 = '[object Object]',
    ValueObjectObject105 = '[object Object]',
    ValueObjectObject106 = '[object Object]',
    ValueObjectObject107 = '[object Object]',
    ValueObjectObject108 = '[object Object]',
    ValueObjectObject109 = '[object Object]',
    ValueObjectObject110 = '[object Object]',
    ValueObjectObject111 = '[object Object]',
    ValueObjectObject112 = '[object Object]',
    ValueObjectObject113 = '[object Object]',
    ValueObjectObject114 = '[object Object]',
    ValueObjectObject115 = '[object Object]',
    ValueObjectObject116 = '[object Object]',
    ValueObjectObject117 = '[object Object]',
    ValueObjectObject118 = '[object Object]',
    ValueObjectObject119 = '[object Object]',
    ValueObjectObject120 = '[object Object]',
    ValueObjectObject121 = '[object Object]',
    ValueObjectObject122 = '[object Object]',
    ValueObjectObject123 = '[object Object]',
    ValueObjectObject124 = '[object Object]',
    ValueObjectObject125 = '[object Object]',
    ValueObjectObject126 = '[object Object]',
    ValueObjectObject127 = '[object Object]',
    ValueObjectObject128 = '[object Object]',
    ValueObjectObject129 = '[object Object]',
    ValueObjectObject130 = '[object Object]',
    ValueObjectObject131 = '[object Object]',
    ValueObjectObject132 = '[object Object]',
    ValueObjectObject133 = '[object Object]',
    ValueObjectObject134 = '[object Object]',
    ValueObjectObject135 = '[object Object]',
    ValueObjectObject136 = '[object Object]',
    ValueObjectObject137 = '[object Object]',
    ValueObjectObject138 = '[object Object]',
    ValueObjectObject139 = '[object Object]',
    ValueObjectObject140 = '[object Object]',
    ValueObjectObject141 = '[object Object]',
    ValueObjectObject142 = '[object Object]',
    ValueObjectObject143 = '[object Object]',
    ValueObjectObject144 = '[object Object]',
    ValueObjectObject145 = '[object Object]',
    ValueObjectObject146 = '[object Object]',
    ValueObjectObject147 = '[object Object]',
    ValueObjectObject148 = '[object Object]',
    ValueObjectObject149 = '[object Object]',
    ValueObjectObject150 = '[object Object]',
    ValueObjectObject151 = '[object Object]',
    ValueObjectObject152 = '[object Object]',
    ValueObjectObject153 = '[object Object]',
    ValueObjectObject154 = '[object Object]',
    ValueObjectObject155 = '[object Object]',
    ValueObjectObject156 = '[object Object]',
    ValueObjectObject157 = '[object Object]',
    ValueObjectObject158 = '[object Object]',
    ValueObjectObject159 = '[object Object]',
    ValueObjectObject160 = '[object Object]',
    ValueObjectObject161 = '[object Object]',
    ValueObjectObject162 = '[object Object]',
    ValueObjectObject163 = '[object Object]',
    ValueObjectObject164 = '[object Object]',
    ValueObjectObject165 = '[object Object]',
    ValueObjectObject166 = '[object Object]',
    ValueObjectObject167 = '[object Object]',
    ValueObjectObject168 = '[object Object]',
    ValueObjectObject169 = '[object Object]',
    ValueObjectObject170 = '[object Object]',
    ValueObjectObject171 = '[object Object]',
    ValueObjectObject172 = '[object Object]',
    ValueObjectObject173 = '[object Object]',
    ValueObjectObject174 = '[object Object]',
    ValueObjectObject175 = '[object Object]',
    ValueObjectObject176 = '[object Object]',
    ValueObjectObject177 = '[object Object]',
    ValueObjectObject178 = '[object Object]',
    ValueObjectObject179 = '[object Object]',
    ValueObjectObject180 = '[object Object]',
    ValueObjectObject181 = '[object Object]',
    ValueObjectObject182 = '[object Object]',
    ValueObjectObject183 = '[object Object]',
    ValueObjectObject184 = '[object Object]',
    ValueObjectObject185 = '[object Object]',
    ValueObjectObject186 = '[object Object]',
    ValueObjectObject187 = '[object Object]',
    ValueObjectObject188 = '[object Object]',
    ValueObjectObject189 = '[object Object]',
    ValueObjectObject190 = '[object Object]',
    ValueObjectObject191 = '[object Object]',
    ValueObjectObject192 = '[object Object]',
    ValueObjectObject193 = '[object Object]',
    ValueObjectObject194 = '[object Object]',
    ValueObjectObject195 = '[object Object]',
    ValueObjectObject196 = '[object Object]',
    ValueObjectObject197 = '[object Object]',
    ValueObjectObject198 = '[object Object]',
    ValueObjectObject199 = '[object Object]',
    ValueObjectObject200 = '[object Object]',
    ValueObjectObject201 = '[object Object]',
    ValueObjectObject202 = '[object Object]',
    ValueObjectObject203 = '[object Object]',
    ValueObjectObject204 = '[object Object]',
    ValueObjectObject205 = '[object Object]',
    ValueObjectObject206 = '[object Object]',
    ValueObjectObject207 = '[object Object]',
    ValueObjectObject208 = '[object Object]',
    ValueObjectObject209 = '[object Object]',
    ValueObjectObject210 = '[object Object]',
    ValueObjectObject211 = '[object Object]',
    ValueObjectObject212 = '[object Object]',
    ValueObjectObject213 = '[object Object]',
    ValueObjectObject214 = '[object Object]',
    ValueObjectObject215 = '[object Object]',
    ValueObjectObject216 = '[object Object]',
    ValueObjectObject217 = '[object Object]',
    ValueObjectObject218 = '[object Object]',
    ValueObjectObject219 = '[object Object]',
    ValueObjectObject220 = '[object Object]',
    ValueObjectObject221 = '[object Object]',
    ValueObjectObject222 = '[object Object]',
    ValueObjectObject223 = '[object Object]',
    ValueObjectObject224 = '[object Object]',
    ValueObjectObject225 = '[object Object]',
    ValueObjectObject226 = '[object Object]',
    ValueObjectObject227 = '[object Object]',
    ValueObjectObject228 = '[object Object]',
    ValueObjectObject229 = '[object Object]',
    ValueObjectObject230 = '[object Object]',
    ValueObjectObject231 = '[object Object]',
    ValueObjectObject232 = '[object Object]',
    ValueObjectObject233 = '[object Object]',
    ValueObjectObject234 = '[object Object]',
    ValueObjectObject235 = '[object Object]',
    ValueObjectObject236 = '[object Object]',
    ValueObjectObject237 = '[object Object]',
    ValueObjectObject238 = '[object Object]',
    ValueObjectObject239 = '[object Object]',
    ValueObjectObject240 = '[object Object]',
    ValueObjectObject241 = '[object Object]',
    ValueObjectObject242 = '[object Object]',
    ValueObjectObject243 = '[object Object]',
    ValueObjectObject244 = '[object Object]',
    ValueObjectObject245 = '[object Object]',
    ValueObjectObject246 = '[object Object]',
    ValueObjectObject247 = '[object Object]',
    ValueObjectObject248 = '[object Object]',
}

/** CreateReplyScheduleModel */
export interface CreateReplyScheduleModel {
    /**
     * Send Time
     * @format date-time
     */
    send_time: string
    repeat: ReplyScheduleRepeat
    /** Contexts */
    contexts: string[]
    /** Weekdays */
    weekdays?: ReplyScheduleWeekDays[] | null
    /** Text */
    text?: string | null
    /** Image Url */
    image_url?: string | null
    /** Voice Url */
    voice_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
    /** Agent */
    agent?: string | null
    /** Files */
    files?: string[] | null
}

/** DeletionReason */
export enum DeletionReason {
    ValueПерехожуНаДругойСервисАналог = 'Перехожу на другой сервис/аналог',
    ValueНеУстраиваетКачествоСервиса = 'Не устраивает качество сервиса',
    ValueРедкоПользуюсьАккаунтом = 'Редко пользуюсь аккаунтом',
    ValueСложныйНеудобныйИнтерфейс = 'Сложный/неудобный интерфейс',
    ValueНеХватаетНужныхМнеФункций = 'Не хватает нужных мне функций',
    ValueЧастыеТехническиеОшибкиСбои = 'Частые технические ошибки/сбои',
    ValueСлишкомДорого = 'Слишком дорого',
    ValueЕстьДругойАккаунтПерехожуНаНего = 'Есть другой аккаунт, перехожу на него',
    ValueДругаяПричинаУкажуВКомментарии = 'Другая причина (укажу в комментарии)',
}

/** DepositCreateOutputDTO */
export interface DepositCreateOutputDTO {
    action: PaymentActionDTO
    /**
     * Deposit Uuid
     * @format uuid
     */
    deposit_uuid: string
}

/** EmailVerifyResendCodeOutputDTO */
export type EmailVerifyResendCodeOutputDTO = object

/** EmailVerifyResendModel */
export interface EmailVerifyResendModel {
    /** Email Verify Id */
    email_verify_id: number
}

/** EmailVerifyStartOutputDTO */
export interface EmailVerifyStartOutputDTO {
    /** Email Verify Id */
    email_verify_id: number
}

/** GetTokenBySecurityTokenModel */
export interface GetTokenBySecurityTokenModel {
    /** Security Token */
    security_token: string
}

/** GetTokenBySecurityTokenOutputDTO */
export interface GetTokenBySecurityTokenOutputDTO {
    /** Auth Token */
    auth_token: string
}

/** GetUserByTokenModel */
export interface GetUserByTokenModel {
    /** Auth Token */
    auth_token: string
}

/** GetUserByUserinfoModel */
export interface GetUserByUserinfoModel {
    /** Sub */
    sub: string
    /** Email */
    email: string
}

/** HTTPValidationError */
export interface HTTPValidationError {
    /** Detail */
    detail?: ValidationError[]
}

/** HttpMethod */
export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
}

/** HttpRedirectType */
export enum HttpRedirectType {
    Self = '_self',
    Blank = '_blank',
    Parent = '_parent',
    Top = '_top',
}

/** ImageImagineOutputDTO */
export interface ImageImagineOutputDTO {
    /** Model Slug */
    model_slug: string
    model_output: ImageModelOutputDTO
}

/** ImageModelOutputDTO */
export interface ImageModelOutputDTO {
    /** Generation Task Id */
    generation_task_id: string
    /** Image Url */
    image_url: string[]
    /** Status */
    status: string
    /** Error Description */
    error_description: string
    error_category?: AIErrorCategory | null
}

/** ImageRerollOutputDTO */
export interface ImageRerollOutputDTO {
    /** Model Slug */
    model_slug: string
    model_output: RerollModelOutputDTO
}

/** IncreaseType */
export enum IncreaseType {
    DEPOSIT = 'DEPOSIT',
    BONUS = 'BONUS',
    PROMOCODE = 'PROMOCODE',
    REFERRAL = 'REFERRAL',
}

/** Keys */
export interface Keys {
    /** P256Dh */
    p256dh: string
    /** Auth */
    auth: string
}

/** LLMModelAliasDTO */
export interface LLMModelAliasDTO {
    /** Alias */
    alias: string
    model_type: ModelType
    /** Kind */
    kind: string
    model: ModelSlug
}

/** LLMModelDTO */
export interface LLMModelDTO {
    slug: ModelSlug
    /** Title */
    title: string
    /** Description */
    description: string
    legal: LegalProperties
    /** Series Slug */
    series_slug: string
    model_type: ModelType
    /** Model Subtype */
    model_subtype: string
    /** Available For Stream */
    available_for_stream: boolean
    series?: LLMModelSeries | null
    /**
     * Is Restricted
     * @default false
     */
    is_restricted?: boolean
    /**
     * Is Disabled
     * @default false
     */
    is_disabled?: boolean
    /**
     * Is Free
     * @default false
     */
    is_free?: boolean
    /**
     * Is Protected
     * @default false
     */
    is_protected?: boolean
    /** Supported Content */
    supported_content?: ModelFileRestriction[] | null
    /** Estimated Price */
    estimated_price?: string | null
    /** Average Answer Time */
    average_answer_time?: number | null
    /** Average Output Tokens */
    average_output_tokens?: number | null
    developer?: ModelDeveloper | null
    /** Model Specialization */
    model_specialization?: string | null
}

/** LLMModelGroupDTO */
export interface LLMModelGroupDTO {
    /** Models */
    models: LLMModelDTO[]
    developer?: ModelDeveloper | null
}

/** LLMModelListOutputDTO */
export interface LLMModelListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: LLMModelDTO[]
}

/** LLMModelRestrictModel */
export interface LLMModelRestrictModel {
    /** Restrictions */
    restrictions: LLMModelRestrictUnitModel[]
}

/** LLMModelRestrictUnitModel */
export interface LLMModelRestrictUnitModel {
    model_slug: ModelSlug
    /** Is Restricted */
    is_restricted: boolean
}

/** LLMModelRestrictedBulkUpsertOutputDTO */
export interface LLMModelRestrictedBulkUpsertOutputDTO {
    /** Success Count */
    success_count: number
    /** Error Count */
    error_count: number
}

/** LLMModelSeries */
export interface LLMModelSeries {
    /** Slug */
    slug: string
    /** Title */
    title: string
    /** Params */
    params: (BoolParam | RangeParam | SelectOneParam)[]
    /** Additional Contexts */
    additional_contexts: (SelectOneParam | SelectMultipleParam)[]
}

/** LLMToolDTO */
export interface LLMToolDTO {
    /** Slug */
    slug: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Parameters */
    parameters: LLMToolParam[]
    /**
     * Is Disabled
     * @default false
     */
    is_disabled?: boolean
}

/** LLMToolListOutputDTO */
export interface LLMToolListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: LLMToolDTO[]
}

/** LLMToolParam */
export interface LLMToolParam {
    /** Name */
    name: string
    param_type: LLMToolParamType
    /** Description */
    description: string
    /** Required */
    required: boolean
}

/** LLMToolParamType */
export enum LLMToolParamType {
    Number = 'number',
    String = 'string',
}

/** LLMToolState */
export enum LLMToolState {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    ENFORCED = 'ENFORCED',
}

/** LegalProperties */
export interface LegalProperties {
    origin: Country
}

/** MeetingCreateModel */
export interface MeetingCreateModel {
    /**
     * Source
     * @format uri
     * @minLength 1
     * @maxLength 2083
     */
    source: string
    /** Title */
    title?: string | null
    /** Start At */
    start_at?: string | null
    /** Workplace Id */
    workplace_id?: string | null
}

/** MeetingDTO */
export interface MeetingDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Source
     * @format uri
     * @minLength 1
     * @maxLength 2083
     */
    source: string
    /** Title */
    title: string | null
    status: MeetingStatus
    /** Output File */
    output_file: string | null
    /** Workplace Id */
    workplace_id: string | null
    /** Record Id */
    record_id: string | null
    /**
     * Start At
     * @format date-time
     */
    start_at: string
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
}

/** MeetingDeleteOutputDTO */
export type MeetingDeleteOutputDTO = object

/** MeetingListOutputDTO */
export interface MeetingListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: MeetingDTO[]
}

/** MeetingStatus */
export enum MeetingStatus {
    SCHEDULED = 'SCHEDULED',
    PREPARING = 'PREPARING',
    PROCESSING = 'PROCESSING',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
}

/** MeetingUpdateModel */
export interface MeetingUpdateModel {
    /**
     * Start At
     * @format date-time
     */
    start_at: string
}

/** MemoDTO */
export interface MemoDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * Record Id
     * @format uuid
     */
    record_id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Content */
    content: string | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Data */
    data: Record<string, any>
    settings: MemoSettings
}

/** MemoListOutputDTO */
export interface MemoListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: MemoShortDTO[]
}

/** MemoPromptListOutputDTO */
export interface MemoPromptListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: MemoPromptShortDTO[]
}

/** MemoPromptPrivacy */
export enum MemoPromptPrivacy {
    SYSTEM_PRESET = 'SYSTEM_PRESET',
    PRIVATE = 'PRIVATE',
}

/** MemoPromptShortDTO */
export interface MemoPromptShortDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /** User Uuid */
    user_uuid: string | null
    /** Title */
    title: string
    /** Description */
    description: string
    model: ModelSlug
    privacy: MemoPromptPrivacy
    /**
     * Created At
     * @format date-time
     */
    created_at: string
}

/** MemoPublicDTO */
export interface MemoPublicDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /** Content */
    content: string | null
}

/** MemoSettings */
export interface MemoSettings {
    /** Memo Prompt Id */
    memo_prompt_id?: string | null
    /** Workplace Context */
    workplace_context?: string | null
    /** Extra Context */
    extra_context?: string | null
}

/** MemoShortDTO */
export interface MemoShortDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * Record Id
     * @format uuid
     */
    record_id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
}

/** MemoUpdateModel */
export interface MemoUpdateModel {
    /** Content */
    content: string
}

/** MobilePush */
export interface MobilePush {
    /**
     * User Uuid
     * UUID пользователя
     * @format uuid
     */
    user_uuid: string
    platform: MobilePushPlatformEnum
    /**
     * Token
     * Пуш-токен устройства
     * @minLength 8
     */
    token: string
    /** Osversion */
    osVersion?: string | null
    /** Locale */
    locale?: string | null
    /** Extra Metadata */
    extra_metadata?: Record<string, any> | null
    /** Id */
    id: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Updated At */
    updated_at?: string | null
}

/** MobilePushCreateInput */
export interface MobilePushCreateInput {
    /** User Uuid */
    user_uuid?: null
    platform: MobilePushPlatformEnum
    /**
     * Token
     * Пуш-токен устройства
     * @minLength 8
     */
    token: string
    /** Osversion */
    osVersion?: string | null
    /** Locale */
    locale?: string | null
    /** Extra Metadata */
    extra_metadata?: Record<string, any> | null
}

/** MobilePushPlatformEnum */
export enum MobilePushPlatformEnum {
    Android = 'android',
    Ios = 'ios',
}

/** ModelDeveloper */
export enum ModelDeveloper {
    OpenAI = 'OpenAI',
    Google = 'Google',
    Anthropic = 'Anthropic',
    XAI = 'xAI',
    Yandex = 'Yandex',
    DeepSeekAI = 'DeepSeek AI',
    Videogram = 'Videogram',
    Perplexity = 'Perplexity',
    QwenAlibaba = 'Qwen (Alibaba)',
    StabilityAI = 'Stability AI',
    Midjourney = 'Midjourney',
    HeyGen = 'HeyGen',
    FluxAI = 'Flux AI',
    Kling = 'Kling',
    Hailuo = 'Hailuo',
    Recraft = 'Recraft',
    Veo = 'Veo',
    Qubico = 'Qubico',
    Wanx = 'Wanx',
    MoonshotAI = 'Moonshot AI',
    BlackForestLabs = 'Black Forest Labs',
}

/** ModelFileRestriction */
export interface ModelFileRestriction {
    content_type: ReplyContentType
    /** Is Supported */
    is_supported: boolean
    /** Available Extensions */
    available_extensions?: string[]
    /**
     * Max File Count
     * @default 0
     */
    max_file_count?: number
    /**
     * File Size
     * @default 0
     */
    file_size?: number
    /**
     * Is Required
     * @default false
     */
    is_required?: boolean
}

/** ModelSlug */
export enum ModelSlug {
    AUTO = 'AUTO',
    BEST_TEXT = 'BEST_TEXT',
    OPTIMAL_TEXT = 'OPTIMAL_TEXT',
    BEST_IMAGE = 'BEST_IMAGE',
    OPTIMAL_IMAGE = 'OPTIMAL_IMAGE',
    BEST_VIDEO = 'BEST_VIDEO',
    OPTIMAL_VIDEO = 'OPTIMAL_VIDEO',
    BEST_AUDIO = 'BEST_AUDIO',
    OPTIMAL_AUDIO = 'OPTIMAL_AUDIO',
    BEST_SPEECH = 'BEST_SPEECH',
    OPTIMAL_SPEECH = 'OPTIMAL_SPEECH',
    BEST_RECOGNIZE = 'BEST_RECOGNIZE',
    OPTIMAL_RECOGNIZE = 'OPTIMAL_RECOGNIZE',
    CLAUDE35HAIKU = 'CLAUDE_3.5_HAIKU',
    CLAUDE37SONNETTHINKING = 'CLAUDE_3.7_SONNET_THINKING',
    CLAUDE4OPUS = 'CLAUDE_4_OPUS',
    CLAUDE4SONNET = 'CLAUDE_4_SONNET',
    CLAUDE45SONNET = 'CLAUDE_4_5_SONNET',
    GPT5PRO = 'GPT5_PRO',
    GPT5CODE = 'GPT5_CODE',
    DALLE3 = 'DALL_E_3',
    DEEPSEEKR1 = 'DEEPSEEK_R1',
    DEEPSEEKR1SAFE = 'DEEPSEEK_R1_SAFE',
    DEEPSEEKR1ONLINE = 'DEEPSEEK_R1_ONLINE',
    DEEPSEEKR1QWEN38B = 'DEEPSEEK_R1_QWEN_3_8B',
    DEEPSEEKV31 = 'DEEPSEEK_V3.1',
    DEEPSEEKV31SAFE = 'DEEPSEEK_V3.1_SAFE',
    GEMINI25PROPREVIEW = 'GEMINI2.5_PRO_PREVIEW',
    GEMINIFLASH158B = 'GEMINI_FLASH_1.5_8B',
    GEMINIFLASH20 = 'GEMINI_FLASH_2.0',
    GEMINIFLASH25 = 'GEMINI_FLASH_2.5',
    GOOGLE_FLASH_EDIT = 'GOOGLE_FLASH_EDIT',
    GOOGLE_FLASH_EDIT_MULTI = 'GOOGLE_FLASH_EDIT_MULTI',
    GOOGLEIMAGEN4PREVIEW = 'GOOGLE_IMAGEN_4_PREVIEW',
    GPT41 = 'GPT4.1',
    GPT41MINI = 'GPT4.1_MINI',
    GPT41NANO = 'GPT4.1_NANO',
    GPT5 = 'GPT5',
    GPT5CHAT = 'GPT5_CHAT',
    GPT5MINI = 'GPT5_MINI',
    GPT_OSS_SAFE = 'GPT_OSS_SAFE',
    GPT5NANO = 'GPT5_NANO',
    GPT45 = 'GPT4.5',
    GPT41MINIIMAGE = 'GPT4_1_MINI_IMAGE',
    GPT4LATEST = 'GPT4_LATEST',
    GPT4LATESTMINI = 'GPT4_LATEST_MINI',
    GPT4SEARCH = 'GPT4_SEARCH',
    GPT4OIMAGE = 'GPT_4O_IMAGE',
    GPT5IMAGE = 'GPT5_IMAGE',
    GPT4OMINITTS = 'GPT_4O_MINI_TTS',
    GROK2 = 'GROK_2',
    GROK3BETA = 'GROK_3_BETA',
    GROK3MINIBETA = 'GROK_3_MINI_BETA',
    GROK4 = 'GROK_4',
    HAILUO = 'HAILUO',
    HEYGEN_AVATAR = 'HEYGEN_AVATAR',
    KIMIK2 = 'KIMI_K2',
    KLINGSTANDART16 = 'KLING_STANDART_16',
    MIDJOURNEY = 'MIDJOURNEY',
    OPENAIO1 = 'OPENAI_O1',
    OPENAIO1MINI = 'OPENAI_O1_MINI',
    OPENAIO1PRO = 'OPENAI_O1_PRO',
    OPENAIO3MINI = 'OPENAI_O3_MINI',
    OPENAIO4MINI = 'OPENAI_O4_MINI',
    OPENAI_TTS = 'OPENAI_TTS',
    OPENAI_TTS_HD = 'OPENAI_TTS_HD',
    PERPLEXITY_SONAR = 'PERPLEXITY_SONAR',
    PERPLEXITY_SONAR_DEEP_RESEARCH = 'PERPLEXITY_SONAR_DEEP_RESEARCH',
    QUBICOFLUX1SCHNELL = 'QUBICO_FLUX1_SCHNELL',
    QUBICO_TTS = 'QUBICO_TTS',
    QWENQwQ32B = 'QWEN_QwQ_32B',
    QWENQwQ32BSAFE = 'QWEN_QwQ_32B_SAFE',
    RECRAFTV3 = 'RECRAFT_V3',
    STABLE_AUDIO = 'STABLE_AUDIO',
    VEO3 = 'VEO_3',
    VEO3FAST = 'VEO_3_FAST',
    VEO31 = 'VEO_3_1',
    VEO31FAST = 'VEO_3_1_FAST',
    SORA2 = 'SORA_2',
    VIDEOGRAMV3BALANCED = 'VIDEOGRAM_V3_BALANCED',
    VIDEOGRAMV3QUALITY = 'VIDEOGRAM_V3_QUALITY',
    VIDEOGRAMV3TURBO = 'VIDEOGRAM_V3_TURBO',
    WANX = 'WANX',
    WHISPER = 'WHISPER',
    YANDEX_LATEST = 'YANDEX_LATEST',
    YANDEX_STT = 'YANDEX_STT',
    YANDEX_TTS = 'YANDEX_TTS',
    GOOGLEFLASHEDITMULTI25 = 'GOOGLE_FLASH_EDIT_MULTI_2_5',
    FLUX1KONTEXTMAX = 'FLUX_1_KONTEXT_MAX',
}

/** ModelSpecialization */
export enum ModelSpecialization {
    Art = 'art',
    Universal = 'universal',
    Research = 'research',
    Coding = 'coding',
    Analysis = 'analysis',
}

/** ModelType */
export enum ModelType {
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    AUDIO = 'AUDIO',
    SPEECH = 'SPEECH',
    RECOGNIZE = 'RECOGNIZE',
    AUTO = 'AUTO',
    OTHER = 'OTHER',
}

/** ModelsSetMode */
export enum ModelsSetMode {
    OPTIMAL = 'OPTIMAL',
    BEST = 'BEST',
}

/** NewWebPushSubscription */
export interface NewWebPushSubscription {
    /**
     * Endpoint
     * @minLength 1
     */
    endpoint: string
    keys: Keys
}

/** NotificationEvent */
export interface NotificationEvent {
    /**
     * Code
     * Код события (например 'user_registered', 'order_paid').
     */
    code: string
    /**
     * Title
     * Заголовок события.
     */
    title: string
    /** Тип события. */
    event_type: NotificationEventType
    /**
     * Is Active
     * Флаг активности события.
     * @default true
     */
    is_active?: boolean
    /** Id */
    id: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
}

/** NotificationEventCreate */
export interface NotificationEventCreate {
    /**
     * Code
     * Код события (например 'user_registered', 'order_paid').
     */
    code: string
    /**
     * Title
     * Заголовок события.
     */
    title: string
    /** Тип события. */
    event_type: NotificationEventType
    /**
     * Is Active
     * Флаг активности события.
     * @default true
     */
    is_active?: boolean
}

/** NotificationEventGetList */
export interface NotificationEventGetList {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: any[]
}

/** NotificationEventType */
export enum NotificationEventType {
    INFO = 'INFO',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
}

/** NotificationEventUpdate */
export interface NotificationEventUpdate {
    /** Code */
    code: string
    /** Title */
    title?: string | null
    event_type?: NotificationEventType | null
    /** Is Active */
    is_active?: boolean | null
    /** Deleted At */
    deleted_at?: string | null
}

/** NotificationType */
export enum NotificationType {
    PERSONAL = 'PERSONAL',
    GLOBAL = 'GLOBAL',
}

/** NotificationsChannel */
export enum NotificationsChannel {
    TELEGRAM = 'TELEGRAM',
}

/** PaidAssistantListForGetUser */
export interface PaidAssistantListForGetUser {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: (AssistantSubscription | AssistantFreePeriod)[]
}

/** ParamType */
export enum ParamType {
    BOOL = 'BOOL',
    RANGE = 'RANGE',
    SELECT_ONE = 'SELECT_ONE',
    SELECT_MULTIPLE = 'SELECT_MULTIPLE',
    TEXT = 'TEXT',
}

/** PaymentActionDTO */
export interface PaymentActionDTO {
    action_type: PaymentActionType
    payment_link_data: PaymentLinkData | null
}

/** PaymentActionType */
export enum PaymentActionType {
    NO_ACTION = 'NO_ACTION',
    REDIRECT = 'REDIRECT',
}

/** PaymentLinkData */
export interface PaymentLinkData {
    /**
     * Href
     * @format uri
     * @minLength 1
     * @maxLength 2083
     */
    href: string
    method: HttpMethod
    target: HttpRedirectType
    /** Params */
    params: Record<string, any>
    /** Data */
    data: Record<string, any>
}

/** PushMessageInput */
export interface PushMessageInput {
    /** Platform */
    platform?: null
    /** Token */
    token?: null
    /**
     * Title
     * Notification title
     */
    title: string
    /**
     * Body
     * Notification body
     */
    body: string
    /**
     * Image
     * Optional image URL
     */
    image?: string | null
    /**
     * Sound
     * Notification sound
     * @default "default"
     */
    sound?: string | null
    /**
     * Data
     * Custom payload data
     */
    data?: Record<string, any> | null
}

/** PushMessageTotalCount */
export interface PushMessageTotalCount {
    /** Total */
    total: number
}

/** PushPayload */
export interface PushPayload {
    /** Title */
    title: string
    /** Body */
    body: string
    /** Url */
    url?: string | null
}

/** RMRModel */
export interface RMRModel {
    /**
     * Record Id
     * @format uuid
     */
    record_id: string
    record_stage_type: RecordStageType
    settings: RecordStageMemoSettings
}

/** RangeParam */
export interface RangeParam {
    /** Name */
    name: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Min Value */
    min_value: number
    /** Max Value */
    max_value: number
    /** Default */
    default: number
    /**
     * Step
     * @default 0.1
     */
    step?: number
    /** @default "RANGE" */
    param_type?: ParamType
}

/** RecordArchiveModel */
export interface RecordArchiveModel {
    /** Is Archived */
    is_archived: boolean
}

/** RecordCreateModel */
export interface RecordCreateModel {
    /** Source */
    source: string
    /** Title */
    title?: string | null
    /** Workplace Id */
    workplace_id: string | null
    /** Memo Prompt Id */
    memo_prompt_id: string | null
    /** Extra Context */
    extra_context?: string | null
    /** @default "INNER" */
    source_type?: RecordSourceType
}

/** RecordDTO */
export interface RecordDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Source */
    source: string
    /** Is Archived */
    is_archived: boolean
    /** Title */
    title: string | null
    /** Workplace Id */
    workplace_id: string | null
    /** Prepared File */
    prepared_file: string | null
    source_info: RecordSourceInfo
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Archived At */
    archived_at?: string | null
    last_stage?: RecordStageDTO | null
}

/** RecordDeleteOutputDTO */
export type RecordDeleteOutputDTO = object

/** RecordListOrderOption */
export enum RecordListOrderOption {
    CreatedAt = 'created_at',
    Title = 'title',
}

/** RecordListOutputDTO */
export interface RecordListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: RecordDTO[]
}

/** RecordSourceInfo */
export interface RecordSourceInfo {
    /** Source Url */
    source_url?: string | null
    /** Preview Url */
    preview_url?: string | null
    /** Duration Sec */
    duration_sec?: number | null
}

/** RecordSourceType */
export enum RecordSourceType {
    INNER = 'INNER',
    EXTERNAL = 'EXTERNAL',
}

/** RecordStageDTO */
export interface RecordStageDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * Record Id
     * @format uuid
     */
    record_id: string
    stage_type: RecordStageType
    status: RecordStageStatus
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
}

/** RecordStageMemoSettings */
export interface RecordStageMemoSettings {
    /** Memo Prompt Id */
    memo_prompt_id?: string | null
    /** Extra Context */
    extra_context?: string | null
}

/** RecordStageStatus */
export enum RecordStageStatus {
    SCHEDULED = 'SCHEDULED',
    PROCESSING = 'PROCESSING',
    ERROR = 'ERROR',
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
}

/** RecordStageType */
export enum RecordStageType {
    RECORD_PREPARE = 'RECORD_PREPARE',
    CONVERT = 'CONVERT',
    STENOGRAPHY = 'STENOGRAPHY',
    FORMATTING = 'FORMATTING',
    MEMO = 'MEMO',
}

/** RecordStenographyChunkDTO */
export interface RecordStenographyChunkDTO {
    /** Start Second */
    start_second: number
    /** End Second */
    end_second: number | null
    /** Text */
    text: string
    /** Data */
    data: Record<string, any>
    /** Speaker Name */
    speaker_name: string | null
}

/** RecordStenographyDTO */
export interface RecordStenographyDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Record Id */
    record_id: string | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Updated At */
    updated_at: string | null
    /** Chunks */
    chunks: RecordStenographyChunkDTO[]
}

/** RecordStenographyListOutputDTO */
export interface RecordStenographyListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: RecordStenographyShortDTO[]
}

/** RecordStenographyPublicDTO */
export interface RecordStenographyPublicDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /** Chunks */
    chunks: RecordStenographyChunkDTO[]
}

/** RecordStenographyShortDTO */
export interface RecordStenographyShortDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Record Id */
    record_id: string | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Updated At */
    updated_at: string | null
}

/** RecordUpdateModel */
export interface RecordUpdateModel {
    /** Title */
    title?: string | null
}

/** RecurringPaymentDetailOutputDTO */
export interface RecurringPaymentDetailOutputDTO {
    /** User Uuid */
    user_uuid?: string | null
    /** Created At */
    created_at?: string | null
    /** Updated At */
    updated_at?: string | null
    /** Minimum Amount */
    minimum_amount?: number | null
    /** Previous Invoice Id */
    previous_invoice_id?: string | null
    /** Is Active */
    is_active?: boolean | null
    /** Deactivated At */
    deactivated_at?: string | null
    tariff?: TariffDTO | null
}

/** RecurringPaymentUpdateModel */
export interface RecurringPaymentUpdateModel {
    /** Is Active */
    is_active?: boolean | null
    /** Minimum Amount */
    minimum_amount?: number | null
    /** Tariff Uuid */
    tariff_uuid?: string | null
}

/** ReplyActor */
export enum ReplyActor {
    USER = 'USER',
    ASSISTANT = 'ASSISTANT',
}

/** ReplyCitationDTO */
export interface ReplyCitationDTO {
    /** Link */
    link: string
    /** Title */
    title: string
    /** Snippet */
    snippet?: string | null
}

/** ReplyContentAudioDTO */
export interface ReplyContentAudioDTO {
    /** @default "AUDIO" */
    content_type?: ReplyContentType
    /** Audio Url */
    audio_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
}

/** ReplyContentAudioVoiceDTO */
export interface ReplyContentAudioVoiceDTO {
    /** @default "AUDIO_VOICE" */
    content_type?: ReplyContentType
    /** Voice Url */
    voice_url: string
    /** Stenography */
    stenography: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
    /** Citations */
    citations?: ReplyCitationDTO[] | null
    /** Reasoning */
    reasoning?: string | null
}

/** ReplyContentDocumentDTO */
export interface ReplyContentDocumentDTO {
    /** @default "DOCUMENT" */
    content_type?: ReplyContentType
    /** File Url */
    file_url: string
    /** Citations */
    citations?: ReplyCitationDTO[] | null
    /** Reasoning */
    reasoning?: string | null
}

/** ReplyContentErrorDTO */
export interface ReplyContentErrorDTO {
    /** @default "ERROR" */
    content_type?: ReplyContentType
    /** Text */
    text: string
    category?: AIErrorCategory | null
}

/** ReplyContentImageDTO */
export interface ReplyContentImageDTO {
    /** @default "IMAGE" */
    content_type?: ReplyContentType
    /** Image Url */
    image_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
}

/** ReplyContentTextDTO */
export interface ReplyContentTextDTO {
    /** @default "TEXT" */
    content_type?: ReplyContentType
    /** Text */
    text: string
    /** Citations */
    citations?: ReplyCitationDTO[] | null
    /** Reasoning */
    reasoning?: string | null
}

/** ReplyContentType */
export enum ReplyContentType {
    TEXT = 'TEXT',
    AUDIO_VOICE = 'AUDIO_VOICE',
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    DOCUMENT = 'DOCUMENT',
    AUDIO = 'AUDIO',
    ERROR = 'ERROR',
}

/** ReplyContentVideoDTO */
export interface ReplyContentVideoDTO {
    /** @default "VIDEO" */
    content_type?: ReplyContentType
    /** Video Url */
    video_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
}

/** ReplyCostOutputDTO */
export interface ReplyCostOutputDTO {
    model_type: ModelType
    /** Minimum Price */
    minimum_price?: number | null
    /** Maximum Price */
    maximum_price?: number | null
    /** Approximate Price */
    approximate_price?: number | null
}

/** ReplyCreateAsyncOutputDTO */
export interface ReplyCreateAsyncOutputDTO {
    user_reply: ReplyDTO | null
    agent_reply: ReplyDTO
    thread?: ThreadShortDTO | null
    /** Agent */
    agent?: string | null
}

/** ReplyDTO */
export interface ReplyDTO {
    /** Id */
    id: number | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    actor: ReplyActor
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Assistant Id */
    assistant_id: number | null
    /** Thread Id */
    thread_id: number | null
    status: ReplyStatus
    /** Content */
    content: (
        | ReplyContentTextDTO
        | ReplyContentAudioVoiceDTO
        | ReplyContentImageDTO
        | ReplyContentVideoDTO
        | ReplyContentAudioDTO
        | ReplyContentDocumentDTO
        | ReplyContentErrorDTO
    )[]
    /** Extra */
    extra: Record<string, any>
    /** Score */
    score?: number | null
    /** Finished At */
    finished_at?: string | null
    /** Est Finish At */
    est_finish_at?: string | null
    /** Seconds To Finish */
    seconds_to_finish?: number | null
    model_slug?: ModelSlug | null
    /** Actor Name */
    actor_name?: string | null
    /**
     * Is Scheduled
     * @default false
     */
    is_scheduled?: boolean
    /** Suggestion Content */
    suggestion_content?: string | null
    /**
     * Is Deleted
     * @default false
     */
    is_deleted?: boolean
    /** Parental Reply Id */
    parental_reply_id?: number | null
    /**
     * Is Regeneration Available
     * @default true
     */
    is_regeneration_available?: boolean
    /** Linked Replies */
    linked_replies?: ReplyDTO[] | null
}

/** ReplyDeleteOutputDTO */
export type ReplyDeleteOutputDTO = object

/** ReplyListOutputDTO */
export interface ReplyListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: ReplyDTO[]
}

/** ReplyScheduleDTO */
export interface ReplyScheduleDTO {
    /** Id */
    id: number
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Reply Id */
    reply_id: number
    status: ReplyScheduleStatus
    /** Timing Id */
    timing_id: number | null
    /** Actived */
    actived: boolean
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    reply: ReplyDTO
    timing: ReplyScheduleTiming
    /** Deleted At */
    deleted_at?: string | null
    /** Error Msg */
    error_msg?: string | null
    /** Parent Id */
    parent_id?: number | null
    /** Workplace Id */
    workplace_id?: string | null
}

/** ReplyScheduleDeleteOutputDTO */
export type ReplyScheduleDeleteOutputDTO = object

/** ReplyScheduleListOutputDTO */
export interface ReplyScheduleListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: ReplyScheduleDTO[]
}

/** ReplyScheduleRepeat */
export enum ReplyScheduleRepeat {
    ONCE = 'ONCE',
    EVERYDAY = 'EVERYDAY',
    WEEK_DAYS = 'WEEK_DAYS',
}

/** ReplyScheduleShortDTO */
export interface ReplyScheduleShortDTO {
    /** Id */
    id: number
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Reply Id */
    reply_id: number
    status: ReplyScheduleStatus
    /** Timing Id */
    timing_id: number | null
    /** Actived */
    actived: boolean
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
    /** Error Msg */
    error_msg?: string | null
    /** Parent Id */
    parent_id?: number | null
}

/** ReplyScheduleStatus */
export enum ReplyScheduleStatus {
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    WAITING = 'WAITING',
}

/** ReplyScheduleTiming */
export interface ReplyScheduleTiming {
    /** Id */
    id: number | null
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Send Time
     * @format date-time
     */
    send_time: string
    repeat: ReplyScheduleRepeat
    /** Weekdays */
    weekdays: ReplyScheduleWeekDays[] | null
    /** Is Deleted */
    is_deleted: boolean
}

/** ReplyScheduleWeekDays */
export enum ReplyScheduleWeekDays {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
}

/** ReplyStatus */
export enum ReplyStatus {
    IN_PROCESS = 'IN_PROCESS',
    FINISHED = 'FINISHED',
    FAILED = 'FAILED',
    SCHEDULED = 'SCHEDULED',
    THINKING = 'THINKING',
    ANSWER = 'ANSWER',
}

/** RerollModelOutputDTO */
export interface RerollModelOutputDTO {
    /** Generation Task Id */
    generation_task_id: string
    /** Image Url */
    image_url: string[]
    /** Status */
    status: string
    /** Error Description */
    error_description: string
    error_category?: AIErrorCategory | null
}

/** SelectMultipleParam */
export interface SelectMultipleParam {
    /** Name */
    name: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Values */
    values: any[]
    /** Default */
    default: any[]
    /** @default "SELECT_MULTIPLE" */
    param_type?: ParamType
}

/** SelectOneParam */
export interface SelectOneParam {
    /** Name */
    name: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Values */
    values: any[]
    /** Default */
    default: any
    /** @default "SELECT_ONE" */
    param_type?: ParamType
}

/** ServiceChargeDTO */
export interface ServiceChargeDTO {
    /** Id */
    id: number | null
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Corporative Account Id */
    corporative_account_id: number | null
    /** Operation Id */
    operation_id: string
    /** Source */
    source: string
    /** Balance Charge */
    balance_charge: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Is Service */
    is_service: boolean
    /** Description */
    description?: string | null
    /** @default "ACCEPT" */
    change_status?: ServiceChargeStatus
    /** Data */
    data?: Record<string, any>
    /** Batch Uuid */
    batch_uuid?: string | null
}

/** ServiceChargeOutputDTO */
export interface ServiceChargeOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: ServiceChargeDTO[]
}

/** ServiceChargeStatus */
export enum ServiceChargeStatus {
    FREEZE = 'FREEZE',
    ACCEPT = 'ACCEPT',
    REFUND = 'REFUND',
}

/** SortType */
export enum SortType {
    DESC = 'DESC',
    ASC = 'ASC',
}

/** StenographyChunkDTO */
export interface StenographyChunkDTO {
    /** Channel Tag */
    channel_tag: string
    /** Start Second */
    start_second: number
    /** End Second */
    end_second: number
    /** Text */
    text: string
    /** Speaker Name */
    speaker_name: string | null
}

/** StenographyDTO */
export interface StenographyDTO {
    /** Id */
    id: string | null
    /** User Uuid */
    user_uuid: string | null
    /** Source */
    source: string | null
    status: StenographyStatus
    /** Content */
    content: StenographyChunkDTO[]
}

/** StenographyStatus */
export enum StenographyStatus {
    NEW = 'NEW',
    IN_PROCESS = 'IN_PROCESS',
    DONE = 'DONE',
    FAILED = 'FAILED',
}

/** StorageTariff */
export interface StorageTariff {
    /** Name */
    name: string
    /**
     * Storage Gb
     * @min 1
     */
    storage_gb: number
    /** @default "MONTH" */
    period?: StorageTariffPeriodEnum
    /**
     * Price Coins
     * @min 0
     */
    price_coins: number
    /** Id */
    id: number
    /** Is Active */
    is_active: boolean
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
}

/** StorageTariffGetList */
export interface StorageTariffGetList {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: StorageTariff[]
}

/** StorageTariffPeriodEnum */
export enum StorageTariffPeriodEnum {
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

/** StorageTariffUser */
export interface StorageTariffUser {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Tariff Id */
    tariff_id: number
    /**
     * Auto Renew
     * @default true
     */
    auto_renew?: boolean
    /** @default "PENDING" */
    auto_renew_status?: AutoRenewStatusEnum
    /**
     * Auto Renew Attempts
     * @default 0
     */
    auto_renew_attempts?: number
    /** Start At */
    start_at?: string | null
    /** End At */
    end_at?: string | null
    /**
     * Is Active
     * @default true
     */
    is_active?: boolean
    /** Id */
    id: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
    storage_tariff: StorageTariff
}

/** StorageTariffUserAvailableStorage */
export interface StorageTariffUserAvailableStorage {
    /** Max Storage Limit */
    max_storage_limit: number
}

/** StorageTariffUserGetListActiveForUser */
export interface StorageTariffUserGetListActiveForUser {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: StorageTariffUser[]
}

/** StorageTariffUserInputCreate */
export interface StorageTariffUserInputCreate {
    /** Tariff Id */
    tariff_id: number
    /**
     * Auto Renew
     * @default true
     */
    auto_renew?: boolean
}

/** StorageTariffUserInputUpdate */
export interface StorageTariffUserInputUpdate {
    /** Tariff Id */
    tariff_id: number
    /** Auto Renew */
    auto_renew?: boolean | null
}

/** TariffDTO */
export interface TariffDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Price */
    price: number
    tariff_type: TariffType
    /**
     * Coins Amount
     * @default 0
     */
    coins_amount?: number
    /**
     * Bonus Coins
     * @default 0
     */
    bonus_coins?: number
    /**
     * Is Disabled
     * @default false
     */
    is_disabled?: boolean
    /** Params */
    params?: Record<string, any> | null
    /** Discount Type */
    discount_type?: string | null
    /** Discount Amount */
    discount_amount?: number | null
    /** Discount End Datetime */
    discount_end_datetime?: string | null
    /** Price With Discount */
    price_with_discount?: number | null
    restrictions?: TariffTypeRestrictionsDTO | null
}

/** TariffListOutputDTO */
export interface TariffListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: TariffDTO[]
}

/** TariffType */
export enum TariffType {
    START = 'START',
    OPTIMAL = 'OPTIMAL',
    PROFESSIONAL = 'PROFESSIONAL',
    INFINITY = 'INFINITY',
    GUEST = 'GUEST',
    FREE = 'FREE',
}

/** TariffTypeRestrictionsDTO */
export interface TariffTypeRestrictionsDTO {
    tariff_type: TariffType
    /** Available Models */
    available_models: string[]
    /** Available Assistants */
    available_assistants: number[]
    /** Is Recording Available */
    is_recording_available: boolean
}

/** TelegramConnectAssistantModel */
export interface TelegramConnectAssistantModel {
    /** Assistant Id */
    assistant_id: number | null
}

/** TempUserTokenOutputDTO */
export interface TempUserTokenOutputDTO {
    /** Access Token */
    access_token: string
    /** Expires In */
    expires_in: number
    /** Refresh Expires In */
    refresh_expires_in: number
    /** Refresh Token */
    refresh_token: string
}

/** TextParam */
export interface TextParam {
    /** Name */
    name: string
    /** Title */
    title: string
    /** Description */
    description: string
    /** Default */
    default: string
    /** @default "TEXT" */
    param_type?: ParamType
}

/** ThreadAdditionalContextDTO */
export interface ThreadAdditionalContextDTO {
    /** Name */
    name: string
    /** Value */
    value: string | string[] | number
}

/** ThreadArchiveModel */
export interface ThreadArchiveModel {
    /** Is Archived */
    is_archived: boolean
}

/** ThreadDTO */
export interface ThreadDTO {
    /** Id */
    id: number | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Name */
    name: string
    /** Rag Enabled */
    rag_enabled: boolean
    /** Voice Answer */
    voice_answer: boolean
    /** Deep Research Enabled */
    deep_research_enabled: boolean
    /** Context */
    context: string
    /** Is Archived */
    is_archived: boolean
    /** Agent */
    agent: string
    /** Memory Message Count */
    memory_message_count: number
    /** Archived At */
    archived_at?: string | null
    /** Assistant Id */
    assistant_id?: number | null
    /** Last Message */
    last_message?: string | null
    last_message_type?: ReplyContentType | null
    /** Last Message Timestamp */
    last_message_timestamp?: string | null
    /** Workplace Id */
    workplace_id?: string | null
    /** Params */
    params?: ThreadModelParamDTO[] | null
    /** Additional Contexts */
    additional_contexts?: ThreadAdditionalContextDTO[] | null
    /** Llm Tools */
    llm_tools?: ThreadLLMToolDTO[] | null
    /**
     * Shared
     * @default false
     */
    shared?: boolean
    /** Speech Voice */
    speech_voice?: string | null
    /** Voice Speed */
    voice_speed?: number | null
    /**
     * Disable Info Messages
     * @default false
     */
    disable_info_messages?: boolean
    /** Scheduled Reply Count */
    scheduled_reply_count?: number | null
}

/** ThreadDeleteOutputDTO */
export type ThreadDeleteOutputDTO = object

/** ThreadLLMToolDTO */
export interface ThreadLLMToolDTO {
    /** Name */
    name: string
    state: LLMToolState
}

/** ThreadListOutputDTO */
export interface ThreadListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: ThreadShortDTO[]
}

/** ThreadModelParamDTO */
export interface ThreadModelParamDTO {
    /** Name */
    name: string
    /** Value */
    value: string | number
}

/** ThreadShortDTO */
export interface ThreadShortDTO {
    /** Id */
    id: number | null
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /** Name */
    name: string
    /** Agent */
    agent: string
    /** Memory Message Count */
    memory_message_count: number
    /** Rag Enabled */
    rag_enabled: boolean
    /** Voice Answer */
    voice_answer: boolean
    /** Deep Research Enabled */
    deep_research_enabled: boolean
    /** Is Archived */
    is_archived: boolean
    /** Archived At */
    archived_at?: string | null
    /** Assistant Id */
    assistant_id?: number | null
    /** Last Message */
    last_message?: string | null
    last_message_type?: ReplyContentType | null
    /** Last Message Timestamp */
    last_message_timestamp?: string | null
    /** Workplace Id */
    workplace_id?: string | null
    /** Speech Voice */
    speech_voice?: string | null
    /** Voice Speed */
    voice_speed?: number | null
    /**
     * Disable Info Messages
     * @default false
     */
    disable_info_messages?: boolean
    /** Scheduled Reply Count */
    scheduled_reply_count?: number | null
}

/** ThreadUpdateRequestModel */
export interface ThreadUpdateRequestModel {
    /** Name */
    name?: string | null
    /** Memory Message Count */
    memory_message_count?: number | null
    /** Agent */
    agent?: string | null
    /** Rag Enabled */
    rag_enabled?: boolean | null
    /** Voice Answer */
    voice_answer?: boolean | null
    /** Speech Voice */
    speech_voice?: string | null
    /** Voice Speed */
    voice_speed?: number | null
    /** Deep Research Enabled */
    deep_research_enabled?: boolean | null
    /** Context */
    context?: string | null
    /** Params */
    params?: ThreadModelParamDTO[] | null
    /** Additional Contexts */
    additional_contexts?: ThreadAdditionalContextDTO[] | null
    /** Llm Tools */
    llm_tools?: ThreadLLMToolDTO[] | null
    /** Shared */
    shared?: boolean | null
    /** Disable Info Messages */
    disable_info_messages?: boolean | null
}

/** UnsubscribeBody */
export interface UnsubscribeBody {
    /** Endpoint */
    endpoint: string
}

/** UpdateReplyScheduleModel */
export interface UpdateReplyScheduleModel {
    /** Send Time */
    send_time?: string | null
    repeat?: ReplyScheduleRepeat | null
    /** Weekdays */
    weekdays?: ReplyScheduleWeekDays[] | null
    /** Files */
    files?: string[] | null
    /** Text */
    text?: string | null
    /** Image Url */
    image_url?: string | null
    /** Voice Url */
    voice_url?: string | null
    /** Generation Task Id */
    generation_task_id?: string | null
}

/** UserAIDefaultsDTO */
export interface UserAIDefaultsDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    model_set_mode: ModelsSetMode
}

/** UserAIDefaultsUpdateModel */
export interface UserAIDefaultsUpdateModel {
    model_set_mode?: ModelsSetMode | null
}

/** UserAssistantUpdateModel */
export interface UserAssistantUpdateModel {
    /** Is Favorite */
    is_favorite?: boolean | null
}

/** UserDeleteModel */
export interface UserDeleteModel {
    deletion_reason: DeletionReason
    /** Comment */
    comment?: string | null
}

/** UserFeedSettings */
export interface UserFeedSettings {
    /**
     * Feed Settings Task Events
     * @default true
     */
    feed_settings_task_events?: boolean
    /**
     * Feed Settings Account Management
     * @default true
     */
    feed_settings_account_management?: boolean
    /**
     * Feed Settings News
     * @default true
     */
    feed_settings_news?: boolean
}

/** UserInfoModel */
export interface UserInfoModel {
    /**
     * Feed Settings Task Events
     * @default true
     */
    feed_settings_task_events?: boolean
    /**
     * Feed Settings Account Management
     * @default true
     */
    feed_settings_account_management?: boolean
    /**
     * Feed Settings News
     * @default true
     */
    feed_settings_news?: boolean
    /**
     * Email
     * @format email
     */
    email: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Firstname */
    firstname?: string | null
    /** Lastname */
    lastname?: string | null
    /** Profile Pic */
    profile_pic?: string | null
    /**
     * Is New
     * @default false
     */
    is_new?: boolean
    /** Social Id */
    social_id?: string | null
    /** Banners */
    banners?: Record<string, any> | null
}

/** UserInfoUpdateModel */
export interface UserInfoUpdateModel {
    /** Firstname */
    firstname?: string | null
    /** Lastname */
    lastname?: string | null
    /** Profile Pic */
    profile_pic?: string | null
    /** Banners */
    banners?: Record<string, any> | null
}

/** UserLoginOutputDTO */
export interface UserLoginOutputDTO {
    /** Token */
    token: string
}

/** UserNotification */
export interface UserNotification {
    /**
     * User Uuid
     * UUID пользователя.
     */
    user_uuid: string | null
    /**
     * Тип уведомления.
     * @default "GLOBAL"
     */
    notification_type?: NotificationType
    /**
     * Event Id
     * ID события (notification_events.id).
     */
    event_id: number
    /**
     * Message
     * Текст уведомления.
     */
    message: string
    /** Action Url */
    action_url?: string | null
    /** Action Text */
    action_text?: string | null
    /** Payload */
    payload?: null
    /**
     * Is Read
     * Статус прочтения.
     * @default false
     */
    is_read?: boolean
    /** Id */
    id: number
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Updated At
     * @format date-time
     */
    updated_at: string
    /** Deleted At */
    deleted_at?: string | null
    event: NotificationEvent
}

/** UserNotificationCreateWithoutUser */
export interface UserNotificationCreateWithoutUser {
    /** User Uuid */
    user_uuid?: null
    /**
     * Тип уведомления.
     * @default "GLOBAL"
     */
    notification_type?: NotificationType
    /**
     * Event Id
     * ID события (notification_events.id).
     */
    event_id: number
    /**
     * Message
     * Текст уведомления.
     */
    message: string
    /** Action Url */
    action_url?: string | null
    /** Action Text */
    action_text?: string | null
    /** Payload */
    payload?: null
    /**
     * Is Read
     * Статус прочтения.
     * @default false
     */
    is_read?: boolean
}

/** UserNotificationGetList */
export interface UserNotificationGetList {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: any[]
}

/** UserNotificationTotalCount */
export interface UserNotificationTotalCount {
    /** Total */
    total: number
}

/** UserNotificationUpdate */
export interface UserNotificationUpdate {
    /**
     * Id
     * Table id.
     */
    id: number
    /** Message */
    message?: string | null
    /** Action Url */
    action_url?: string | null
    /** Payload */
    payload?: null
    /** Is Read */
    is_read?: boolean | null
    /** Deleted At */
    deleted_at?: string | null
}

/** UserNotificationsModel */
export interface UserNotificationsModel {
    notification_channel: NotificationsChannel
    /** Is Enabled */
    is_enabled: boolean
}

/** UserNotificationsSettingsDTO */
export interface UserNotificationsSettingsDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    notifications_channel: NotificationsChannel
    /** Is Enabled */
    is_enabled: boolean
}

/** UserPasswordChange */
export interface UserPasswordChange {
    /** Password Old */
    password_old: string
    /**
     * Password New
     * @minLength 6
     * @maxLength 100
     */
    password_new: string
}

/** UserPasswordChangeServiceOutputDTO */
export type UserPasswordChangeServiceOutputDTO = object

/** UserPasswordResetCompleteModel */
export interface UserPasswordResetCompleteModel {
    /** Token */
    token: string
    /** Password */
    password: string
    /** Password2 */
    password2: string
}

/** UserPasswordResetCompleteServiceOutputDTO */
export type UserPasswordResetCompleteServiceOutputDTO = object

/** UserPasswordResetGetTokenModel */
export interface UserPasswordResetGetTokenModel {
    /** Email Verify Id */
    email_verify_id: number
    /** Code */
    code: string
}

/** UserPasswordResetGetTokenServiceOutputDTO */
export interface UserPasswordResetGetTokenServiceOutputDTO {
    /** Reset Token */
    reset_token: string
}

/** UserPasswordResetModel */
export interface UserPasswordResetModel {
    /**
     * Email
     * @format email
     */
    email: string
}

/** UserPasswordResetStartServiceOutputDTO */
export interface UserPasswordResetStartServiceOutputDTO {
    /** Email Verify Id */
    email_verify_id: number
}

/** UserReferralBalanceIncreaseDTO */
export interface UserReferralBalanceIncreaseDTO {
    /** Amount */
    amount: number
    /** Bonus Amount */
    bonus_amount: number
    /** Email */
    email?: string | null
    /** Profile Pic */
    profile_pic?: string | null
}

/** UserReferralBalanceIncreaseListOutputDTO */
export interface UserReferralBalanceIncreaseListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: UserReferralBalanceIncreaseDTO[]
}

/** UserReferralInfoDTO */
export interface UserReferralInfoDTO {
    /** Referral Count */
    referral_count: number
    /** Bonus Amount */
    bonus_amount: number
}

/** UserRegisterModel */
export interface UserRegisterModel {
    /**
     * Email
     * @format email
     */
    email: string
    /**
     * Password
     * @maxLength 64
     */
    password: string
    /**
     * Password2
     * @maxLength 64
     */
    password2: string
}

/** UserShortDTO */
export interface UserShortDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Is Active */
    is_active: boolean
    /** Is Superuser */
    is_superuser: boolean
    /**
     * Email
     * @format email
     */
    email: string
    /** Is Email Validated */
    is_email_validated: boolean
    /** Firstname */
    firstname: string | null
    /** Lastname */
    lastname: string | null
    /** Profile Pic */
    profile_pic: string | null
    /** Rag Size Mb */
    rag_size_mb?: number | null
    /** Keycloak Id */
    keycloak_id?: string | null
    /**
     * Restricted
     * @default false
     */
    restricted?: boolean
    /**
     * Is New
     * @default false
     */
    is_new?: boolean
    /**
     * Is Temp
     * @default false
     */
    is_temp?: boolean
    tariff_type?: TariffType | null
    /** Tariff Title */
    tariff_title?: string | null
    /** Feed Settings Task Events */
    feed_settings_task_events?: boolean | null
    /** Feed Settings Account Management */
    feed_settings_account_management?: boolean | null
    /** Feed Settings News */
    feed_settings_news?: boolean | null
    /** Banners */
    banners?: Record<string, any> | null
}

/** UserTariffActivateInputModel */
export interface UserTariffActivateInputModel {
    /**
     * Tariff Uuid
     * @format uuid
     */
    tariff_uuid: string
}

/** UserTariffDTO */
export interface UserTariffDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Id */
    id?: number | null
    /** Tariff Uuid */
    tariff_uuid?: string | null
    /** Is Active */
    is_active?: boolean | null
    /** Is Recurring */
    is_recurring?: boolean | null
    tariff?: TariffDTO | null
}

/** UserWalletDTO */
export interface UserWalletDTO {
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Corporative Wallet Id */
    corporative_wallet_id: number | null
    /** Available Balance */
    available_balance: number
    tariff_type?: TariffType | null
    /** Tariff Title */
    tariff_title?: string | null
}

/** ValidationError */
export interface ValidationError {
    /** Location */
    loc: (string | number)[]
    /** Message */
    msg: string
    /** Error Type */
    type: string
}

/** WIDepositCreateModel */
export interface WIDepositCreateModel {
    /** Amount */
    amount: number
    /** Tariff Uuid */
    tariff_uuid?: string | null
    /**
     * Is Recurring
     * @default false
     */
    is_recurring?: boolean
}

/** WebPushSubscription */
export interface WebPushSubscription {
    /** Id */
    id?: number | null
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /**
     * Endpoint
     * @minLength 1
     */
    endpoint: string
    keys: Keys
    /**
     * Is Active
     * @default true
     */
    is_active?: boolean
    /** Created At */
    created_at?: string | null
    /** Updated At */
    updated_at?: string | null
    /** Deleted At */
    deleted_at?: string | null
}

/** WorkplaceArchiveModel */
export interface WorkplaceArchiveModel {
    /** Is Archived */
    is_archived: boolean
}

/** WorkplaceCreateModel */
export interface WorkplaceCreateModel {
    /** Title */
    title: string
    /**
     * Is Protected
     * @default false
     */
    is_protected?: boolean
}

/** WorkplaceDTO */
export interface WorkplaceDTO {
    /**
     * Id
     * @format uuid
     */
    id: string
    /**
     * User Uuid
     * @format uuid
     */
    user_uuid: string
    /** Title */
    title: string
    /** Context */
    context: string
    settings: WorkplaceSettingsDTO
    /**
     * Created At
     * @format date-time
     */
    created_at: string
    /**
     * Is Active
     * @default true
     */
    is_active?: boolean
    /**
     * Is Archived
     * @default false
     */
    is_archived?: boolean
    /**
     * Is Protected
     * @default false
     */
    is_protected?: boolean
    /** Archived At */
    archived_at?: string | null
}

/** WorkplaceDeleteOutputDTO */
export type WorkplaceDeleteOutputDTO = object

/** WorkplaceListOutputDTO */
export interface WorkplaceListOutputDTO {
    /** Total Count */
    total_count: number
    /** Limit */
    limit: number
    /** Offset */
    offset: number
    /** Objects */
    objects: WorkplaceDTO[]
}

/** WorkplaceSettingsDTO */
export interface WorkplaceSettingsDTO {
    /**
     * Rag Enabled
     * @default true
     */
    rag_enabled?: boolean
}

/** WorkplaceSettingsModel */
export interface WorkplaceSettingsModel {
    /** Rag Enabled */
    rag_enabled?: boolean | null
}

export interface DefTestKafkaTestKafkaGetParams {
    /** Colab Event Sender */
    colab_event_sender?: any
}

export interface ReplyScheduleListApiV1ReplyScheduleGetParams {
    /**
     * Limit
     * Limit of the workplaces to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Date From
     * Start date for filtering schedule replies
     * @format date-time
     */
    date_from?: string
    /**
     * Date To
     * End date for filtering schedule replies
     * @format date-time
     */
    date_to?: string
}

export interface ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetParams {
    /**
     * Limit
     * Limit of the workplaces to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Date From
     * Start date for filtering schedule replies
     * @format date-time
     */
    date_from?: string
    /**
     * Date To
     * End date for filtering schedule replies
     * @format date-time
     */
    date_to?: string
}

export interface ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetParams {
    /**
     * Limit
     * Limit of the workplaces to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Thread Id */
    threadId: number
}

export interface CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostParams {
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
    /** Thread Id */
    threadId: number
}

export interface CreateThreadApiV1CollaborationAppThreadPostParams {
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface ThreadListApiV1CollaborationAppThreadGetParams {
    /**
     * Is Archived
     * Archived
     */
    is_archived?: boolean | null
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /**
     * Workplace Id
     * Workplace id
     */
    workplace_id?: string | null
    /**
     * Assistant Id
     * Assitant id
     */
    assistant_id?: number | null
}

export interface CreateReplyApiV1CollaborationAppReplyPostParams {
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface ReplyListApiV1CollaborationAppReplyGetParams {
    /** Thread Id */
    thread_id?: number | null
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
}

export interface ReplyCostApiV1CollaborationAppReplyCostGetParams {
    /** Thread Id */
    thread_id?: number | null
    /** Assistant Id */
    assistant_id?: number | null
    /** Model Slug */
    model_slug?: ModelSlug | null
    /** Reply Content */
    reply_content?: string | null
    /**
     * Web Search Used
     * @default false
     */
    web_search_used?: boolean | null
    /**
     * Rag Enabled
     * @default true
     */
    rag_enabled?: boolean | null
    /**
     * Voice Answer
     * @default false
     */
    voice_answer?: boolean | null
    /**
     * Memory Message Count
     * @default 3
     */
    memory_message_count?: number | null
}

export interface ReplyListShareApiV1CollaborationAppReplyShareGetParams {
    /**
     * Thread Id
     * @default 0
     */
    thread_id?: number
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Reply List Uc */
    reply_list_uc?: any
}

export interface ReplyDetailApiV1CollaborationAppReplyReplyIdGetParams {
    /** Reply Detail Use Case */
    reply_detail_use_case?: any
    /** Reply Id */
    replyId: number
}

export interface RateReplyApiV1CollaborationAppReplyReplyIdRatePostParams {
    /** Reply Rate Use Case */
    reply_rate_use_case?: any
    /** Reply Id */
    replyId: number
}

export interface CreateWorkplaceApiV1CollaborationAppWorkplacePostParams {
    /** Workplace Create Uc */
    workplace_create_uc?: any
}

export interface WorkplaceListApiV1CollaborationAppWorkplaceGetParams {
    /**
     * Is Archived
     * Archived
     */
    is_archived?: boolean | null
    /**
     * Limit
     * Limit of the workplaces to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /** Workplace List Uc */
    workplace_list_uc?: any
}

export interface WorkplaceDetailApiV1CollaborationAppWorkplaceWorkplaceIdGetParams {
    /** Workplace Detail Use Case */
    workplace_detail_use_case?: any
    /**
     * Workplace Id
     * @format uuid
     */
    workplaceId: string
}

export interface WorkplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatchParams {
    /** Workplace Update Use Case */
    workplace_update_use_case?: any
    /**
     * Workplace Id
     * @format uuid
     */
    workplaceId: string
}

export interface WorkplaceDeleteApiV1CollaborationAppWorkplaceWorkplaceIdDeleteParams {
    /** Workplace Delete Use Case */
    workplace_delete_use_case?: any
    /**
     * Workplace Id
     * @format uuid
     */
    workplaceId: string
}

export interface WorkplaceArchiveApiV1CollaborationAppWorkplaceWorkplaceIdArchivePostParams {
    /** Workplace Archive Service */
    workplace_archive_service?: any
    /** Workplace Unarchive Service */
    workplace_unarchive_service?: any
    /**
     * Workplace Id
     * @format uuid
     */
    workplaceId: string
}

export interface CreateRecordApiV1CollaborationAppRecordPostParams {
    /** Record Create Service */
    record_create_service?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface RecordListApiV1CollaborationAppRecordGetParams {
    /**
     * Is Archived
     * Archived
     */
    is_archived?: boolean | null
    /**
     * Limit
     * Limit of the records to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /**
     * Field order by
     * @default "created_at"
     */
    order_by?: RecordListOrderOption
    /**
     * Workplace Id
     * Workplace ID
     * @format uuid
     */
    workplace_id?: string
    /** Record List Uc */
    record_list_uc?: any
}

export interface RecordDetailApiV1CollaborationAppRecordRecordIdGetParams {
    /** Record Detail Use Case */
    record_detail_use_case?: any
    /**
     * Record Id
     * @format uuid
     */
    recordId: string
}

export interface RecordUpdateApiV1CollaborationAppRecordRecordIdPatchParams {
    /** Record Update Use Case */
    record_update_use_case?: any
    /**
     * Record Id
     * @format uuid
     */
    recordId: string
}

export interface RecordDeleteApiV1CollaborationAppRecordRecordIdDeleteParams {
    /** Record Delete Use Case */
    record_delete_use_case?: any
    /**
     * Record Id
     * @format uuid
     */
    recordId: string
}

export interface RecordArchiveApiV1CollaborationAppRecordRecordIdArchivePostParams {
    /** Record Archive Use Case */
    record_archive_use_case?: any
    /**
     * Record Id
     * @format uuid
     */
    recordId: string
}

export interface RecordStenographyListApiV1CollaborationAppRecordStenographyGetParams {
    /**
     * Limit
     * Limit of the records to fetch
     * @default 10
     */
    limit?: number
    /**
     * Record Id
     * Limit of the records to fetch
     */
    record_id?: string | null
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /** Record Stenography List Use Case */
    record_stenography_list_use_case?: any
}

export interface RecordStenographyDetailApiV1CollaborationAppRecordStenographyRecordStenographyIdGetParams {
    /** Record Stenography Detail Use Case */
    record_stenography_detail_use_case?: any
    /**
     * Record Stenography Id
     * @format uuid
     */
    recordStenographyId: string
}

export interface RecordStenographyShareApiV1CollaborationAppRecordStenographyRecordStenographyIdShareGetParams {
    /** Record Stenography Detail Share Use Case */
    record_stenography_detail_share_use_case?: any
    /**
     * Record Stenography Id
     * @format uuid
     */
    recordStenographyId: string
}

export interface CreateStageManualRunApiV1CollaborationAppRecordStagePostParams {
    /** Record Stage Manual Run Service */
    record_stage_manual_run_service?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface CreateMeetingApiV1CollaborationAppMeetingPostParams {
    /** Meeting Create Uc */
    meeting_create_uc?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface MeetingListApiV1CollaborationAppMeetingGetParams {
    /**
     * Status  In
     * List of statuses
     */
    status__in?: MeetingStatus[] | null
    /**
     * Workplace Id
     * Workplace id
     */
    workplace_id?: string | null
    /**
     * Start At Date
     * Date
     */
    start_at_date?: string | null
    /**
     * Date From
     * Date
     */
    date_from?: string | null
    /**
     * Date To
     * Date
     */
    date_to?: string | null
    /**
     * Limit
     * Limit of the records to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default False
     * @default false
     */
    desc?: boolean
    /** Meeting List Use Case */
    meeting_list_use_case?: any
}

export interface MeetingDetailApiV1CollaborationAppMeetingMeetingIdGetParams {
    /** Meeting Detail Use Case */
    meeting_detail_use_case?: any
    /**
     * Meeting Id
     * @format uuid
     */
    meetingId: string
}

export interface MeetingUpdateApiV1CollaborationAppMeetingMeetingIdPutParams {
    /** Meeting Update Use Case */
    meeting_update_use_case?: any
    /**
     * Meeting Id
     * @format uuid
     */
    meetingId: string
}

export interface MeetingDeleteApiV1CollaborationAppMeetingMeetingIdDeleteParams {
    /** Meeting Delete Use Case */
    meeting_delete_use_case?: any
    /**
     * Meeting Id
     * @format uuid
     */
    meetingId: string
}

export interface MeetingStopRecordingApiV1CollaborationAppMeetingMeetingIdStopRecordingPostParams {
    /** Meeting Recording Stop Use Case */
    meeting_recording_stop_use_case?: any
    /**
     * Meeting Id
     * @format uuid
     */
    meetingId: string
}

export interface MemoListApiV1CollaborationAppMemoGetParams {
    /**
     * Limit
     * Limit of the records to fetch
     * @default 10
     */
    limit?: number
    /**
     * Record Id
     * Limit of the records to fetch
     */
    record_id?: string | null
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /** Memo List Use Case */
    memo_list_use_case?: any
}

export interface MemoDetailApiV1CollaborationAppMemoMemoIdGetParams {
    /** Memo Detail Use Case */
    memo_detail_use_case?: any
    /**
     * Memo Id
     * @format uuid
     */
    memoId: string
}

export interface MemoUpdateApiV1CollaborationAppMemoMemoIdPutParams {
    /** Memo Update Use Case */
    memo_update_use_case?: any
    /**
     * Memo Id
     * @format uuid
     */
    memoId: string
}

export interface MemoDetailShareApiV1CollaborationAppMemoMemoIdShareGetParams {
    /** Memo Detail Share Use Case */
    memo_detail_share_use_case?: any
    /**
     * Memo Id
     * @format uuid
     */
    memoId: string
}

export interface MemoPromptListApiV1CollaborationAppMemoPromptGetParams {
    /**
     * Model  In
     * List of models
     */
    model__in?: string[] | null
    /**
     * Model  Not In
     * List of excluded models
     */
    model__not_in?: string[] | null
    /**
     * Limit
     * Limit of the memo_prompts to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /** Memo Prompt List Uc */
    memo_prompt_list_uc?: any
}

export interface LlmModelListApiV1AiLlmModelGetParams {
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Show Restricted
     * Show restricted by user models
     * @default false
     */
    show_restricted?: boolean
    /**
     * Is Protected
     * Show protected (safe) models
     */
    is_protected?: boolean
    /**
     * Model Specialization
     * Specializations list of models
     */
    model_specialization?: ModelSpecialization[] | null
    /** Llm Model List Uc */
    llm_model_list_uc?: any
}

export interface LlmModelDetailApiV1AiLlmModelLlmModelSlugGetParams {
    /** Llm Model Detail Use Case */
    llm_model_detail_use_case?: any
    llmModelSlug: ModelSlug
}

export interface LlmModelRestrictApiV1AiLlmModelRestrictPostParams {
    /** Llm Model Restricted Bulk Upsert Service */
    llm_model_restricted_bulk_upsert_service?: any
}

export interface LlmToolListApiV1AiLlmToolGetParams {
    /**
     * Limit
     * Limit of the tools to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Llm Tool List Uc */
    llm_tool_list_uc?: any
}

export interface UserAiDefaultsDetailApiV1AiUserAiDefaultsGetParams {
    /** User Ai Defaults Detail Use Case */
    user_ai_defaults_detail_use_case?: any
}

export interface UserAiDefaultsUpdateApiV1AiUserAiDefaultsPatchParams {
    /** User Ai Defaults Update Use Case */
    user_ai_defaults_update_use_case?: any
}

export interface AssistantListApiV1AssistantGetParams {
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Category Id
     * Category
     */
    category_id?: number | null
    /** Category Ids[] */
    'category_ids[]'?: number[] | null
    /**
     * Tags
     * Tags List
     */
    tags?: string | null
    /**
     * Search
     * Search Query
     */
    search?: string | null
    /**
     * Show Restricted
     * Show restricted assistants by user restricted models
     * @default false
     */
    show_restricted?: boolean
    /**
     * Popular
     * Popular
     */
    popular?: boolean | null
    /**
     * Is Protected
     * Return is protected assistants
     */
    is_protected?: boolean | null
    /**
     * Desc
     * Returns a desc sorted list. Default True
     * @default true
     */
    desc?: boolean
    /**
     * Field order by
     * @default "id"
     */
    order_by?: AssistantSortingField
    /** Assistant List Service */
    assistant_list_service?: any
}

export interface AssistantFiltersApiV1AssistantFiltersGetParams {
    /** Assistant Filters Use Case */
    assistant_filters_use_case?: any
}

export interface AssistantDetailApiV1AssistantAssistantIdGetParams {
    /** Assistant Detail Use Case */
    assistant_detail_use_case?: any
    /** Assistant Id */
    assistantId: number
    /** Language */
    language: string
}

export interface AssistantPatchApiV1AssistantAssistantIdPatchParams {
    /** Assistant Update Use Case */
    assistant_update_use_case?: any
    /** Assistant Id */
    assistantId: number
}

export interface AssistantCategoryListApiV1AssistantCategoryGetParams {
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Assistant Category List Uc */
    assistant_category_list_uc?: any
}

export interface CreateStenographyApiV1StenographyPostParams {
    /** Stenography Create Use Case */
    stenography_create_use_case?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface ImagineApiV1ImgImaginePostParams {
    /** Image Imagine Use Case */
    image_imagine_use_case?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface RerollApiV1ImgRerollPostParams {
    /** Image Reroll Use Case */
    image_reroll_use_case?: any
    /**
     * Min Balance
     * @default 1
     */
    min_balance?: number
}

export interface UserRegisterApiV1AuthRegisterPostParams {
    /** Register Uc */
    register_uc?: any
}

export interface TempUserApiV1AuthDemoGetParams {
    /**
     * Assistant Id
     * Assistant ID
     * @default 0
     */
    assistant_id?: number
    /**
     * Checkword
     * Checkword
     * @default ""
     */
    checkword?: string
    /**
     * Utm Source
     * utm_source
     */
    utm_source?: string | null
    /**
     * Utm Medium
     * utm_medium
     */
    utm_medium?: string | null
    /**
     * Utm Campaign
     * utm_campaign
     */
    utm_campaign?: string | null
    /**
     * Utm Content
     * utm_content
     */
    utm_content?: string | null
    /**
     * Referer Uuid
     * referer_uuid
     * @default ""
     */
    referer_uuid?: string
    /** Base Url */
    base_url?: any
    /** Api Domain */
    api_domain?: any
    /** Login Uc */
    login_uc?: any
}

export interface TempUserTokenApiV1AuthDemoTokenGetParams {
    /**
     * Assistant Id
     * Assistant ID
     * @default 0
     */
    assistant_id?: number
    /**
     * Checkword
     * Checkword
     * @default ""
     */
    checkword?: string
    /**
     * Utm Source
     * utm_source
     */
    utm_source?: string | null
    /**
     * Utm Medium
     * utm_medium
     */
    utm_medium?: string | null
    /**
     * Utm Campaign
     * utm_campaign
     */
    utm_campaign?: string | null
    /**
     * Utm Content
     * utm_content
     */
    utm_content?: string | null
    /**
     * Referer Uuid
     * referer_uuid
     * @default ""
     */
    referer_uuid?: string
    /** Login Uc */
    login_uc?: any
}

export interface UserLoginApiV1AuthLoginPostParams {
    /** Login Uc */
    login_uc?: any
}

export interface VerifyUserEmailStartApiV1AuthUserEmailVerifyStartPostParams {
    /** User Email Change Start Service */
    user_email_change_start_service?: any
}

export interface VerifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePostParams {
    /** Verify User Email Uc */
    verify_user_email_uc?: any
}

export interface UserPasswordChangeApiV1AuthUserPasswordChangePostParams {
    /** User Password Change Service */
    user_password_change_service?: any
}

export interface UserPasswordResetStartApiV1AuthUserPasswordResetStartPostParams {
    /** User Password Reset Start Service */
    user_password_reset_start_service?: any
}

export interface UserPasswordResetGetTokenApiV1AuthUserPasswordResetGetTokenPostParams {
    /** User Password Reset Get Token Service */
    user_password_reset_get_token_service?: any
}

export interface UserPasswordResetCompleteApiV1AuthUserPasswordResetCompletePostParams {
    /** User Password Reset Complete Service */
    user_password_reset_complete_service?: any
}

export interface GetTokenBySecurityTokenApiV1AuthGetTokenBySecurityTokenPostParams {
    /** Get Token By Security Token Service */
    get_token_by_security_token_service?: any
}

export interface GetUserByTokenApiV1AuthInnerUserByTokenPostParams {
    /** Auth By Token Use Case */
    auth_by_token_use_case?: any
}

export interface GetUserBySubApiV1AuthInnerUserByUserinfoPostParams {
    /** Auth By Token Use Case */
    auth_by_token_use_case?: any
}

export interface EmailVerifyResendCodeApiV1EmailVerifyResendCodePostParams {
    /** Email Verify Resend Code Use Case */
    email_verify_resend_code_use_case?: any
}

export interface CreateDepositApiV1DepositPostParams {
    /** Deposit Create Use Case */
    deposit_create_use_case?: any
}

export interface GetRecurringPaymentApiV1RecurringPaymentGetParams {
    /** Recurring Payment Detail Use Case */
    recurring_payment_detail_use_case?: any
}

export interface PatchRecurringPaymentApiV1RecurringPaymentPatchParams {
    /** Recurring Payment Update Use Case */
    recurring_payment_update_use_case?: any
}

export interface PostRecurringPaymentApiV1RecurringPaymentPostParams {
    /** Recurring Payment Create Use Case */
    recurring_payment_create_use_case?: any
}

export interface BalanceIncreaseListApiV1BillingBalanceIncreaseGetParams {
    /**
     * Is Service
     * Flag for service transaction
     * @default false
     */
    is_service?: boolean
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Balance Increase List Use Case */
    balance_increase_list_use_case?: any
}

export interface ServiceChargeListApiV1BillingServiceChargeGetParams {
    /**
     * Is Service
     * Flag for service transaction
     * @default false
     */
    is_service?: boolean
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** Service Charge List Use Case */
    service_charge_list_use_case?: any
}

export interface UserWalletGetApiV1WalletGetParams {
    /** User Wallet Use Case */
    user_wallet_use_case?: any
}

export interface ApplyPromocodeApiV1PromocodeApplyPostParams {
    /** Promocode Apply Use Case */
    promocode_apply_use_case?: any
}

export interface UserGetApiV1UserGetParams {
    /** Api Domain */
    api_domain?: any
    /** Social User Use Case */
    social_user_use_case?: any
    /** User Get Use Case */
    user_get_use_case?: any
}

export interface UserUpdateApiV1UserPatchParams {
    /** User Update Use Case */
    user_update_use_case?: any
    /** Social User Use Case */
    social_user_use_case?: any
}

export interface UserDeleteApiV1UserDeletePostParams {
    /** User Delete Use Case */
    user_delete_use_case?: any
}

export interface TariffDetailApiV1TariffTariffUuidGetParams {
    /** Tariff Detail Use Case */
    tariff_detail_use_case?: any
    /**
     * Tariff Uuid
     * @format uuid
     */
    tariffUuid: string
}

export interface TariffListApiV1TariffGetParams {
    /**
     * Limit
     * Limit to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /**
     * Is Disabled
     * Show disabled tariffs
     * @default false
     */
    is_disabled?: boolean
    /** Tariff List Use Case */
    tariff_list_use_case?: any
}

export interface UserTariffActivateApiV1UserTariffActivatePostParams {
    /** User Tariff Activate Use Case */
    user_tariff_activate_use_case?: any
}

export interface UserTariffActiveApiV1UserTariffGetParams {
    /** User Tariff Detail Use Case */
    user_tariff_detail_use_case?: any
}

export interface UserReferralApiV1UserReferralInfoGetParams {
    /** User Referral Detail Use Case */
    user_referral_detail_use_case?: any
}

export interface UserReferralListApiV1UserReferralGetParams {
    /**
     * Limit
     * Limit of the threads to fetch
     * @default 10
     */
    limit?: number
    /**
     * Offset
     * Offset for pagination
     * @default 0
     */
    offset?: number
    /** User Referral List Use Case */
    user_referral_list_use_case?: any
}

export interface GetListApiV1NotificationsFeedEventListGetParams {
    /**
     * Limit
     * @min 0
     * @default 20
     */
    limit?: number
    /**
     * Offset
     * @min 0
     * @default 0
     */
    offset?: number
    /** @default "ASC" */
    sort_by?: SortType
    /** Is Active */
    is_active?: boolean | null
}

export interface ReadApiV1NotificationsFeedUserEventReadIdxPatchParams {
    /**
     * Is Read
     * @default true
     */
    is_read?: boolean
    /** Idx */
    idx: number
}

export interface GetListApiV1NotificationsFeedUserEventListGetParams {
    /**
     * Limit
     * @min 0
     * @default 20
     */
    limit?: number
    /**
     * Offset
     * @min 0
     * @default 0
     */
    offset?: number
    /** @default "ASC" */
    sort_by?: SortType
    /** Is Read */
    is_read?: boolean | null
    /** Date From */
    date_from?: string | null
    /** Date To */
    date_to?: string | null
}

export interface GetListApiV1StorageTariffGetParams {
    /**
     * Limit
     * @min 0
     * @default 20
     */
    limit?: number
    /**
     * Offset
     * @min 0
     * @default 0
     */
    offset?: number
    /** Is Active */
    is_active?: boolean | null
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat
    /** request body */
    body?: unknown
    /** base url */
    baseUrl?: string
    /** request cancellation token */
    cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
    securityWorker?: (
        securityData: SecurityDataType | null,
    ) => Promise<RequestParams | void> | RequestParams | void
    customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
    data: D
    error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = ''
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private abortControllers = new Map<CancelToken, AbortController>()
    private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    }

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig)
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key)
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key])
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key]
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {}
        const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key),
            )
            .join('&')
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery)
        return queryString ? `?${queryString}` : ''
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null && (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string' ? JSON.stringify(input) : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key]
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`,
                )
                return formData
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    }

    protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken)
            if (abortController) {
                return abortController.signal
            }
            return void 0
        }

        const abortController = new AbortController()
        this.abortControllers.set(cancelToken, abortController)
        return abortController.signal
    }

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken)

        if (abortController) {
            abortController.abort()
            this.abortControllers.delete(cancelToken)
        }
    }

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const queryString = query && this.toQueryString(query)
        const payloadFormatter = this.contentFormatters[type || ContentType.Json]
        const responseFormat = format || requestParams.format

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                },
                signal:
                    (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) ||
                    null,
                body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
            },
        ).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>
            r.data = null as unknown as T
            r.error = null as unknown as E

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data
                          } else {
                              r.error = data
                          }
                          return r
                      })
                      .catch((e) => {
                          r.error = e
                          return r
                      })

            if (cancelToken) {
                this.abortControllers.delete(cancelToken)
            }

            if (!response.ok) throw data
            return data
        })
    }
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
    ping = {
        /**
         * No description
         *
         * @name PingPingGet
         * @summary Ping
         * @request GET:/ping
         */
        pingPingGet: (params: RequestParams = {}) =>
            this.request<Record<string, string>, any>({
                path: `/ping`,
                method: 'GET',
                format: 'json',
                ...params,
            }),
    }
    testKafka = {
        /**
         * No description
         *
         * @name DefTestKafkaTestKafkaGet
         * @summary Def Test Kafka
         * @request GET:/test_kafka
         */
        defTestKafkaTestKafkaGet: (
            query: DefTestKafkaTestKafkaGetParams,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/test_kafka`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    }
    api = {
        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleListApiV1ReplyScheduleGet
         * @summary Reply Schedule List
         * @request GET:/api/v1/reply_schedule
         */
        replyScheduleListApiV1ReplyScheduleGet: (
            query: ReplyScheduleListApiV1ReplyScheduleGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleListOutputDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleCalendarApiV1ReplyScheduleCalendarGet
         * @summary Reply Schedule Calendar
         * @request GET:/api/v1/reply_schedule/calendar
         */
        replyScheduleCalendarApiV1ReplyScheduleCalendarGet: (
            query: ReplyScheduleCalendarApiV1ReplyScheduleCalendarGetParams,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/reply_schedule/calendar`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleDetailApiV1ReplyScheduleReplyScheduleIdGet
         * @summary Reply Schedule Detail
         * @request GET:/api/v1/reply_schedule/{reply_schedule_id}
         */
        replyScheduleDetailApiV1ReplyScheduleReplyScheduleIdGet: (
            replyScheduleId: number,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule/${replyScheduleId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch
         * @summary Reply Schedule Update
         * @request PATCH:/api/v1/reply_schedule/{reply_schedule_id}
         */
        replyScheduleUpdateApiV1ReplyScheduleReplyScheduleIdPatch: (
            replyScheduleId: number,
            data: UpdateReplyScheduleModel,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleShortDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule/${replyScheduleId}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete
         * @summary Reply Schedule Delete
         * @request DELETE:/api/v1/reply_schedule/{reply_schedule_id}
         */
        replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete: (
            replyScheduleId: number,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule/${replyScheduleId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet
         * @summary Reply Schedule In Thread List
         * @request GET:/api/v1/reply_schedule/thread/{thread_id}
         */
        replyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGet: (
            {
                threadId,
                ...query
            }: ReplyScheduleInThreadListApiV1ReplyScheduleThreadThreadIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleListOutputDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule/thread/${threadId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Schedule reply
         * @name CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPost
         * @summary Create Reply Schedule
         * @request POST:/api/v1/reply_schedule/thread/{thread_id}
         */
        createReplyScheduleApiV1ReplyScheduleThreadThreadIdPost: (
            { threadId, ...query }: CreateReplyScheduleApiV1ReplyScheduleThreadThreadIdPostParams,
            data: CreateReplyScheduleModel,
            params: RequestParams = {},
        ) =>
            this.request<ReplyScheduleShortDTO, HTTPValidationError>({
                path: `/api/v1/reply_schedule/thread/${threadId}`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name CreateThreadApiV1CollaborationAppThreadPost
         * @summary Create Thread
         * @request POST:/api/v1/collaboration_app/thread
         */
        createThreadApiV1CollaborationAppThreadPost: (
            query: CreateThreadApiV1CollaborationAppThreadPostParams,
            data: BodyCreateThreadApiV1CollaborationAppThreadPost,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadListApiV1CollaborationAppThreadGet
         * @summary Thread List
         * @request GET:/api/v1/collaboration_app/thread
         */
        threadListApiV1CollaborationAppThreadGet: (
            query: ThreadListApiV1CollaborationAppThreadGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ThreadListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name UpdateThreadApiV1CollaborationAppThreadThreadIdPatch
         * @summary Update Thread
         * @request PATCH:/api/v1/collaboration_app/thread/{thread_id}
         */
        updateThreadApiV1CollaborationAppThreadThreadIdPatch: (
            threadId: number,
            data: ThreadUpdateRequestModel,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadDetailApiV1CollaborationAppThreadThreadIdGet
         * @summary Thread Detail
         * @request GET:/api/v1/collaboration_app/thread/{thread_id}
         */
        threadDetailApiV1CollaborationAppThreadThreadIdGet: (
            threadId: number,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadDeleteApiV1CollaborationAppThreadThreadIdDelete
         * @summary Thread Delete
         * @request DELETE:/api/v1/collaboration_app/thread/{thread_id}
         */
        threadDeleteApiV1CollaborationAppThreadThreadIdDelete: (
            threadId: number,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadDetailShareApiV1CollaborationAppThreadThreadIdShareGet
         * @summary Thread Detail Share
         * @request GET:/api/v1/collaboration_app/thread/{thread_id}/share
         */
        threadDetailShareApiV1CollaborationAppThreadThreadIdShareGet: (
            threadId: number,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}/share`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadConnectAssistantApiV1CollaborationAppThreadThreadIdConnectAssistantPost
         * @summary Thread Connect Assistant
         * @request POST:/api/v1/collaboration_app/thread/{thread_id}/connect_assistant
         */
        threadConnectAssistantApiV1CollaborationAppThreadThreadIdConnectAssistantPost: (
            threadId: number,
            data: TelegramConnectAssistantModel,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}/connect_assistant`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Thread
         * @name ThreadArchiveApiV1CollaborationAppThreadThreadIdArchivePost
         * @summary Thread Archive
         * @request POST:/api/v1/collaboration_app/thread/{thread_id}/archive
         */
        threadArchiveApiV1CollaborationAppThreadThreadIdArchivePost: (
            threadId: number,
            data: ThreadArchiveModel,
            params: RequestParams = {},
        ) =>
            this.request<ThreadDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/thread/${threadId}/archive`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name CreateReplyApiV1CollaborationAppReplyPost
         * @summary Create Reply
         * @request POST:/api/v1/collaboration_app/reply
         */
        createReplyApiV1CollaborationAppReplyPost: (
            query: CreateReplyApiV1CollaborationAppReplyPostParams,
            data: BodyCreateReplyApiV1CollaborationAppReplyPost,
            params: RequestParams = {},
        ) =>
            this.request<ReplyCreateAsyncOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name ReplyListApiV1CollaborationAppReplyGet
         * @summary Reply List
         * @request GET:/api/v1/collaboration_app/reply
         */
        replyListApiV1CollaborationAppReplyGet: (
            query: ReplyListApiV1CollaborationAppReplyGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name ReplyCostApiV1CollaborationAppReplyCostGet
         * @summary Reply Cost
         * @request GET:/api/v1/collaboration_app/reply/cost
         * @deprecated
         */
        replyCostApiV1CollaborationAppReplyCostGet: (
            query: ReplyCostApiV1CollaborationAppReplyCostGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyCostOutputDTO[], HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/cost`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name ReplyCostPostApiV1CollaborationAppReplyCostPost
         * @summary Reply Cost Post
         * @request POST:/api/v1/collaboration_app/reply/cost
         */
        replyCostPostApiV1CollaborationAppReplyCostPost: (
            data: BodyReplyCostPostApiV1CollaborationAppReplyCostPost,
            params: RequestParams = {},
        ) =>
            this.request<ReplyCostOutputDTO[], HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/cost`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name ReplyListShareApiV1CollaborationAppReplyShareGet
         * @summary Reply List Share
         * @request GET:/api/v1/collaboration_app/reply/share
         */
        replyListShareApiV1CollaborationAppReplyShareGet: (
            query: ReplyListShareApiV1CollaborationAppReplyShareGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/share`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name ReplyDetailApiV1CollaborationAppReplyReplyIdGet
         * @summary Reply Detail
         * @request GET:/api/v1/collaboration_app/reply/{reply_id}
         */
        replyDetailApiV1CollaborationAppReplyReplyIdGet: (
            { replyId, ...query }: ReplyDetailApiV1CollaborationAppReplyReplyIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ReplyDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/${replyId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name RateReplyApiV1CollaborationAppReplyReplyIdRatePost
         * @summary Rate Reply
         * @request POST:/api/v1/collaboration_app/reply/{reply_id}/rate
         */
        rateReplyApiV1CollaborationAppReplyReplyIdRatePost: (
            { replyId, ...query }: RateReplyApiV1CollaborationAppReplyReplyIdRatePostParams,
            data: BodyRateReplyApiV1CollaborationAppReplyReplyIdRatePost,
            params: RequestParams = {},
        ) =>
            this.request<ReplyDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/${replyId}/rate`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name DeleteRepliesApiV1CollaborationAppReplyDeleteByListPatch
         * @summary Delete Replies
         * @request PATCH:/api/v1/collaboration_app/reply/delete_by_list
         */
        deleteRepliesApiV1CollaborationAppReplyDeleteByListPatch: (
            data: number[],
            params: RequestParams = {},
        ) =>
            this.request<ReplyDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/delete_by_list`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Reply
         * @name RecoverReplyApiV1CollaborationAppReplyReplyIdRecoverPatch
         * @summary Recover Reply
         * @request PATCH:/api/v1/collaboration_app/reply/{reply_id}/recover
         */
        recoverReplyApiV1CollaborationAppReplyReplyIdRecoverPatch: (
            replyId: number,
            params: RequestParams = {},
        ) =>
            this.request<ReplyDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/reply/${replyId}/recover`,
                method: 'PATCH',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name CreateWorkplaceApiV1CollaborationAppWorkplacePost
         * @summary Create Workplace
         * @request POST:/api/v1/collaboration_app/workplace
         */
        createWorkplaceApiV1CollaborationAppWorkplacePost: (
            query: CreateWorkplaceApiV1CollaborationAppWorkplacePostParams,
            data: WorkplaceCreateModel,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name WorkplaceListApiV1CollaborationAppWorkplaceGet
         * @summary Workplace List
         * @request GET:/api/v1/collaboration_app/workplace
         */
        workplaceListApiV1CollaborationAppWorkplaceGet: (
            query: WorkplaceListApiV1CollaborationAppWorkplaceGetParams,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name WorkplaceDetailApiV1CollaborationAppWorkplaceWorkplaceIdGet
         * @summary Workplace Detail
         * @request GET:/api/v1/collaboration_app/workplace/{workplace_id}
         */
        workplaceDetailApiV1CollaborationAppWorkplaceWorkplaceIdGet: (
            {
                workplaceId,
                ...query
            }: WorkplaceDetailApiV1CollaborationAppWorkplaceWorkplaceIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace/${workplaceId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name WorkplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatch
         * @summary Workplace Update
         * @request PATCH:/api/v1/collaboration_app/workplace/{workplace_id}
         */
        workplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatch: (
            {
                workplaceId,
                ...query
            }: WorkplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatchParams,
            data: BodyWorkplaceUpdateApiV1CollaborationAppWorkplaceWorkplaceIdPatch,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace/${workplaceId}`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name WorkplaceDeleteApiV1CollaborationAppWorkplaceWorkplaceIdDelete
         * @summary Workplace Delete
         * @request DELETE:/api/v1/collaboration_app/workplace/{workplace_id}
         */
        workplaceDeleteApiV1CollaborationAppWorkplaceWorkplaceIdDelete: (
            {
                workplaceId,
                ...query
            }: WorkplaceDeleteApiV1CollaborationAppWorkplaceWorkplaceIdDeleteParams,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace/${workplaceId}`,
                method: 'DELETE',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Workplace
         * @name WorkplaceArchiveApiV1CollaborationAppWorkplaceWorkplaceIdArchivePost
         * @summary Workplace Archive
         * @request POST:/api/v1/collaboration_app/workplace/{workplace_id}/archive
         */
        workplaceArchiveApiV1CollaborationAppWorkplaceWorkplaceIdArchivePost: (
            {
                workplaceId,
                ...query
            }: WorkplaceArchiveApiV1CollaborationAppWorkplaceWorkplaceIdArchivePostParams,
            data: WorkplaceArchiveModel,
            params: RequestParams = {},
        ) =>
            this.request<WorkplaceDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/workplace/${workplaceId}/archive`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name CreateRecordApiV1CollaborationAppRecordPost
         * @summary Create Record
         * @request POST:/api/v1/collaboration_app/record
         */
        createRecordApiV1CollaborationAppRecordPost: (
            query: CreateRecordApiV1CollaborationAppRecordPostParams,
            data: RecordCreateModel,
            params: RequestParams = {},
        ) =>
            this.request<RecordDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordListApiV1CollaborationAppRecordGet
         * @summary Record List
         * @request GET:/api/v1/collaboration_app/record
         */
        recordListApiV1CollaborationAppRecordGet: (
            query: RecordListApiV1CollaborationAppRecordGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordDetailApiV1CollaborationAppRecordRecordIdGet
         * @summary Record Detail
         * @request GET:/api/v1/collaboration_app/record/{record_id}
         */
        recordDetailApiV1CollaborationAppRecordRecordIdGet: (
            { recordId, ...query }: RecordDetailApiV1CollaborationAppRecordRecordIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record/${recordId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordUpdateApiV1CollaborationAppRecordRecordIdPatch
         * @summary Record Update
         * @request PATCH:/api/v1/collaboration_app/record/{record_id}
         */
        recordUpdateApiV1CollaborationAppRecordRecordIdPatch: (
            { recordId, ...query }: RecordUpdateApiV1CollaborationAppRecordRecordIdPatchParams,
            data: RecordUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<RecordDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record/${recordId}`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordDeleteApiV1CollaborationAppRecordRecordIdDelete
         * @summary Record Delete
         * @request DELETE:/api/v1/collaboration_app/record/{record_id}
         */
        recordDeleteApiV1CollaborationAppRecordRecordIdDelete: (
            { recordId, ...query }: RecordDeleteApiV1CollaborationAppRecordRecordIdDeleteParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record/${recordId}`,
                method: 'DELETE',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordArchiveApiV1CollaborationAppRecordRecordIdArchivePost
         * @summary Record Archive
         * @request POST:/api/v1/collaboration_app/record/{record_id}/archive
         */
        recordArchiveApiV1CollaborationAppRecordRecordIdArchivePost: (
            {
                recordId,
                ...query
            }: RecordArchiveApiV1CollaborationAppRecordRecordIdArchivePostParams,
            data: RecordArchiveModel,
            params: RequestParams = {},
        ) =>
            this.request<RecordDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record/${recordId}/archive`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordStenographyListApiV1CollaborationAppRecordStenographyGet
         * @summary Record Stenography List
         * @request GET:/api/v1/collaboration_app/record_stenography
         */
        recordStenographyListApiV1CollaborationAppRecordStenographyGet: (
            query: RecordStenographyListApiV1CollaborationAppRecordStenographyGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordStenographyListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record_stenography`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordStenographyDetailApiV1CollaborationAppRecordStenographyRecordStenographyIdGet
         * @summary Record Stenography Detail
         * @request GET:/api/v1/collaboration_app/record_stenography/{record_stenography_id}
         */
        recordStenographyDetailApiV1CollaborationAppRecordStenographyRecordStenographyIdGet: (
            {
                recordStenographyId,
                ...query
            }: RecordStenographyDetailApiV1CollaborationAppRecordStenographyRecordStenographyIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordStenographyDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record_stenography/${recordStenographyId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name RecordStenographyShareApiV1CollaborationAppRecordStenographyRecordStenographyIdShareGet
         * @summary Record Stenography Share
         * @request GET:/api/v1/collaboration_app/record_stenography/{record_stenography_id}/share
         */
        recordStenographyShareApiV1CollaborationAppRecordStenographyRecordStenographyIdShareGet: (
            {
                recordStenographyId,
                ...query
            }: RecordStenographyShareApiV1CollaborationAppRecordStenographyRecordStenographyIdShareGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecordStenographyPublicDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record_stenography/${recordStenographyId}/share`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Record
         * @name CreateStageManualRunApiV1CollaborationAppRecordStagePost
         * @summary Create Stage Manual Run
         * @request POST:/api/v1/collaboration_app/record_stage
         */
        createStageManualRunApiV1CollaborationAppRecordStagePost: (
            query: CreateStageManualRunApiV1CollaborationAppRecordStagePostParams,
            data: RMRModel,
            params: RequestParams = {},
        ) =>
            this.request<RecordDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/record_stage`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name CreateMeetingApiV1CollaborationAppMeetingPost
         * @summary Create Meeting
         * @request POST:/api/v1/collaboration_app/meeting
         */
        createMeetingApiV1CollaborationAppMeetingPost: (
            query: CreateMeetingApiV1CollaborationAppMeetingPostParams,
            data: MeetingCreateModel,
            params: RequestParams = {},
        ) =>
            this.request<MeetingDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name MeetingListApiV1CollaborationAppMeetingGet
         * @summary Meeting List
         * @request GET:/api/v1/collaboration_app/meeting
         */
        meetingListApiV1CollaborationAppMeetingGet: (
            query: MeetingListApiV1CollaborationAppMeetingGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MeetingListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name MeetingDetailApiV1CollaborationAppMeetingMeetingIdGet
         * @summary Meeting Detail
         * @request GET:/api/v1/collaboration_app/meeting/{meeting_id}
         */
        meetingDetailApiV1CollaborationAppMeetingMeetingIdGet: (
            { meetingId, ...query }: MeetingDetailApiV1CollaborationAppMeetingMeetingIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MeetingDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting/${meetingId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name MeetingUpdateApiV1CollaborationAppMeetingMeetingIdPut
         * @summary Meeting Update
         * @request PUT:/api/v1/collaboration_app/meeting/{meeting_id}
         */
        meetingUpdateApiV1CollaborationAppMeetingMeetingIdPut: (
            { meetingId, ...query }: MeetingUpdateApiV1CollaborationAppMeetingMeetingIdPutParams,
            data: MeetingUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<MeetingDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting/${meetingId}`,
                method: 'PUT',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name MeetingDeleteApiV1CollaborationAppMeetingMeetingIdDelete
         * @summary Meeting Delete
         * @request DELETE:/api/v1/collaboration_app/meeting/{meeting_id}
         */
        meetingDeleteApiV1CollaborationAppMeetingMeetingIdDelete: (
            { meetingId, ...query }: MeetingDeleteApiV1CollaborationAppMeetingMeetingIdDeleteParams,
            params: RequestParams = {},
        ) =>
            this.request<MeetingDeleteOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting/${meetingId}`,
                method: 'DELETE',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Meeting
         * @name MeetingStopRecordingApiV1CollaborationAppMeetingMeetingIdStopRecordingPost
         * @summary Meeting Stop Recording
         * @request POST:/api/v1/collaboration_app/meeting/{meeting_id}/stop_recording
         */
        meetingStopRecordingApiV1CollaborationAppMeetingMeetingIdStopRecordingPost: (
            {
                meetingId,
                ...query
            }: MeetingStopRecordingApiV1CollaborationAppMeetingMeetingIdStopRecordingPostParams,
            params: RequestParams = {},
        ) =>
            this.request<MeetingDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/meeting/${meetingId}/stop_recording`,
                method: 'POST',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Memo
         * @name MemoListApiV1CollaborationAppMemoGet
         * @summary Memo List
         * @request GET:/api/v1/collaboration_app/memo
         */
        memoListApiV1CollaborationAppMemoGet: (
            query: MemoListApiV1CollaborationAppMemoGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MemoListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/memo`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Memo
         * @name MemoDetailApiV1CollaborationAppMemoMemoIdGet
         * @summary Memo Detail
         * @request GET:/api/v1/collaboration_app/memo/{memo_id}
         */
        memoDetailApiV1CollaborationAppMemoMemoIdGet: (
            { memoId, ...query }: MemoDetailApiV1CollaborationAppMemoMemoIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MemoDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/memo/${memoId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Memo
         * @name MemoUpdateApiV1CollaborationAppMemoMemoIdPut
         * @summary Memo Update
         * @request PUT:/api/v1/collaboration_app/memo/{memo_id}
         */
        memoUpdateApiV1CollaborationAppMemoMemoIdPut: (
            { memoId, ...query }: MemoUpdateApiV1CollaborationAppMemoMemoIdPutParams,
            data: MemoUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<MemoDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/memo/${memoId}`,
                method: 'PUT',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Memo
         * @name MemoDetailShareApiV1CollaborationAppMemoMemoIdShareGet
         * @summary Memo Detail Share
         * @request GET:/api/v1/collaboration_app/memo/{memo_id}/share
         */
        memoDetailShareApiV1CollaborationAppMemoMemoIdShareGet: (
            { memoId, ...query }: MemoDetailShareApiV1CollaborationAppMemoMemoIdShareGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MemoPublicDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/memo/${memoId}/share`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Memo
         * @name MemoPromptListApiV1CollaborationAppMemoPromptGet
         * @summary Memo Prompt List
         * @request GET:/api/v1/collaboration_app/memo_prompt
         */
        memoPromptListApiV1CollaborationAppMemoPromptGet: (
            query: MemoPromptListApiV1CollaborationAppMemoPromptGetParams,
            params: RequestParams = {},
        ) =>
            this.request<MemoPromptListOutputDTO, HTTPValidationError>({
                path: `/api/v1/collaboration_app/memo_prompt`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Model
         * @name LlmModelListApiV1AiLlmModelGet
         * @summary Llm Model List
         * @request GET:/api/v1/ai/llm_model
         */
        llmModelListApiV1AiLlmModelGet: (
            query: LlmModelListApiV1AiLlmModelGetParams,
            params: RequestParams = {},
        ) =>
            this.request<LLMModelListOutputDTO, HTTPValidationError>({
                path: `/api/v1/ai/llm_model`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Model
         * @name LlmModelGroupApiV1AiLlmModelGroupGet
         * @summary Llm Model Group
         * @request GET:/api/v1/ai/llm_model/group
         */
        llmModelGroupApiV1AiLlmModelGroupGet: (params: RequestParams = {}) =>
            this.request<LLMModelGroupDTO[], HTTPValidationError>({
                path: `/api/v1/ai/llm_model/group`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Model
         * @name LlmModelAliasApiV1AiLlmModelAliasGet
         * @summary Llm Model Alias
         * @request GET:/api/v1/ai/llm_model/alias
         */
        llmModelAliasApiV1AiLlmModelAliasGet: (params: RequestParams = {}) =>
            this.request<LLMModelAliasDTO[], HTTPValidationError>({
                path: `/api/v1/ai/llm_model/alias`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Model
         * @name LlmModelDetailApiV1AiLlmModelLlmModelSlugGet
         * @summary Llm Model Detail
         * @request GET:/api/v1/ai/llm_model/{llm_model_slug}
         */
        llmModelDetailApiV1AiLlmModelLlmModelSlugGet: (
            { llmModelSlug, ...query }: LlmModelDetailApiV1AiLlmModelLlmModelSlugGetParams,
            params: RequestParams = {},
        ) =>
            this.request<LLMModelDTO, HTTPValidationError>({
                path: `/api/v1/ai/llm_model/${llmModelSlug}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Model
         * @name LlmModelRestrictApiV1AiLlmModelRestrictPost
         * @summary Llm Model Restrict
         * @request POST:/api/v1/ai/llm_model/restrict
         */
        llmModelRestrictApiV1AiLlmModelRestrictPost: (
            query: LlmModelRestrictApiV1AiLlmModelRestrictPostParams,
            data: LLMModelRestrictModel,
            params: RequestParams = {},
        ) =>
            this.request<LLMModelRestrictedBulkUpsertOutputDTO, HTTPValidationError>({
                path: `/api/v1/ai/llm_model/restrict`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM Tool
         * @name LlmToolListApiV1AiLlmToolGet
         * @summary Llm Tool List
         * @request GET:/api/v1/ai/llm_tool
         */
        llmToolListApiV1AiLlmToolGet: (
            query: LlmToolListApiV1AiLlmToolGetParams,
            params: RequestParams = {},
        ) =>
            this.request<LLMToolListOutputDTO, HTTPValidationError>({
                path: `/api/v1/ai/llm_tool`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM User settings
         * @name UserAiDefaultsDetailApiV1AiUserAiDefaultsGet
         * @summary User Ai Defaults Detail
         * @request GET:/api/v1/ai/user_ai_defaults
         */
        userAiDefaultsDetailApiV1AiUserAiDefaultsGet: (
            query: UserAiDefaultsDetailApiV1AiUserAiDefaultsGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserAIDefaultsDTO, HTTPValidationError>({
                path: `/api/v1/ai/user_ai_defaults`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags LLM User settings
         * @name UserAiDefaultsUpdateApiV1AiUserAiDefaultsPatch
         * @summary User Ai Defaults Update
         * @request PATCH:/api/v1/ai/user_ai_defaults
         */
        userAiDefaultsUpdateApiV1AiUserAiDefaultsPatch: (
            query: UserAiDefaultsUpdateApiV1AiUserAiDefaultsPatchParams,
            data: UserAIDefaultsUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<UserAIDefaultsDTO, HTTPValidationError>({
                path: `/api/v1/ai/user_ai_defaults`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assistant
         * @name AssistantListApiV1AssistantGet
         * @summary Assistant List
         * @request GET:/api/v1/assistant
         */
        assistantListApiV1AssistantGet: (
            query: AssistantListApiV1AssistantGetParams,
            params: RequestParams = {},
        ) =>
            this.request<AssistantListOutputDTO, HTTPValidationError>({
                path: `/api/v1/assistant`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assistant
         * @name AssistantFiltersApiV1AssistantFiltersGet
         * @summary Assistant Filters
         * @request GET:/api/v1/assistant/filters
         */
        assistantFiltersApiV1AssistantFiltersGet: (
            query: AssistantFiltersApiV1AssistantFiltersGetParams,
            params: RequestParams = {},
        ) =>
            this.request<AssistantFiltersOutputDTO, HTTPValidationError>({
                path: `/api/v1/assistant/filters`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assistant
         * @name AssistantDetailApiV1AssistantAssistantIdGet
         * @summary Assistant Detail
         * @request GET:/api/v1/assistant/{assistant_id}
         */
        assistantDetailApiV1AssistantAssistantIdGet: (
            { assistantId, ...query }: AssistantDetailApiV1AssistantAssistantIdGetParams,
            params: RequestParams = {},
        ) =>
            this.request<AssistantDTO, HTTPValidationError>({
                path: `/api/v1/assistant/${assistantId}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assistant
         * @name AssistantPatchApiV1AssistantAssistantIdPatch
         * @summary Assistant Patch
         * @request PATCH:/api/v1/assistant/{assistant_id}
         */
        assistantPatchApiV1AssistantAssistantIdPatch: (
            { assistantId, ...query }: AssistantPatchApiV1AssistantAssistantIdPatchParams,
            data: UserAssistantUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<AssistantDTO, HTTPValidationError>({
                path: `/api/v1/assistant/${assistantId}`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Assistant
         * @name AssistantCategoryListApiV1AssistantCategoryGet
         * @summary Assistant Category List
         * @request GET:/api/v1/assistant_category
         */
        assistantCategoryListApiV1AssistantCategoryGet: (
            query: AssistantCategoryListApiV1AssistantCategoryGetParams,
            params: RequestParams = {},
        ) =>
            this.request<AssistantCategoryListOutputDTO, HTTPValidationError>({
                path: `/api/v1/assistant_category`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Stenography
         * @name CreateStenographyApiV1StenographyPost
         * @summary Create Stenography
         * @request POST:/api/v1/stenography
         */
        createStenographyApiV1StenographyPost: (
            query: CreateStenographyApiV1StenographyPostParams,
            data: string,
            params: RequestParams = {},
        ) =>
            this.request<StenographyDTO, HTTPValidationError>({
                path: `/api/v1/stenography`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Image
         * @name ImagineApiV1ImgImaginePost
         * @summary Imagine
         * @request POST:/api/v1/img/imagine
         */
        imagineApiV1ImgImaginePost: (
            query: ImagineApiV1ImgImaginePostParams,
            data: BodyImagineApiV1ImgImaginePost,
            params: RequestParams = {},
        ) =>
            this.request<ImageImagineOutputDTO, HTTPValidationError>({
                path: `/api/v1/img/imagine`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Image
         * @name RerollApiV1ImgRerollPost
         * @summary Reroll
         * @request POST:/api/v1/img/reroll
         */
        rerollApiV1ImgRerollPost: (
            query: RerollApiV1ImgRerollPostParams,
            data: BodyRerollApiV1ImgRerollPost,
            params: RequestParams = {},
        ) =>
            this.request<ImageRerollOutputDTO, HTTPValidationError>({
                path: `/api/v1/img/reroll`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserRegisterApiV1AuthRegisterPost
         * @summary User Register
         * @request POST:/api/v1/auth/register
         */
        userRegisterApiV1AuthRegisterPost: (
            query: UserRegisterApiV1AuthRegisterPostParams,
            data: UserRegisterModel,
            params: RequestParams = {},
        ) =>
            this.request<EmailVerifyStartOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/register`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name TempUserApiV1AuthDemoGet
         * @summary Temp User
         * @request GET:/api/v1/auth/demo
         */
        tempUserApiV1AuthDemoGet: (
            query: TempUserApiV1AuthDemoGetParams,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/auth/demo`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name TempUserTokenApiV1AuthDemoTokenGet
         * @summary Temp User Token
         * @request GET:/api/v1/auth/demo_token
         */
        tempUserTokenApiV1AuthDemoTokenGet: (
            query: TempUserTokenApiV1AuthDemoTokenGetParams,
            params: RequestParams = {},
        ) =>
            this.request<TempUserTokenOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/demo_token`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserLoginApiV1AuthLoginPost
         * @summary User Login
         * @request POST:/api/v1/auth/login
         */
        userLoginApiV1AuthLoginPost: (
            query: UserLoginApiV1AuthLoginPostParams,
            data: BodyUserLoginApiV1AuthLoginPost,
            params: RequestParams = {},
        ) =>
            this.request<UserLoginOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/login`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name VerifyUserEmailStartApiV1AuthUserEmailVerifyStartPost
         * @summary Verify User Email Start
         * @request POST:/api/v1/auth/user_email_verify/start
         */
        verifyUserEmailStartApiV1AuthUserEmailVerifyStartPost: (
            query: VerifyUserEmailStartApiV1AuthUserEmailVerifyStartPostParams,
            data: string,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/auth/user_email_verify/start`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name VerifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePost
         * @summary Verify User Email Complete
         * @request POST:/api/v1/auth/user_email_verify/complete
         */
        verifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePost: (
            query: VerifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePostParams,
            data: BodyVerifyUserEmailCompleteApiV1AuthUserEmailVerifyCompletePost,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/auth/user_email_verify/complete`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserPasswordChangeApiV1AuthUserPasswordChangePost
         * @summary User Password Change
         * @request POST:/api/v1/auth/user_password_change
         */
        userPasswordChangeApiV1AuthUserPasswordChangePost: (
            query: UserPasswordChangeApiV1AuthUserPasswordChangePostParams,
            data: UserPasswordChange,
            params: RequestParams = {},
        ) =>
            this.request<UserPasswordChangeServiceOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/user_password_change`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserPasswordResetStartApiV1AuthUserPasswordResetStartPost
         * @summary User Password Reset Start
         * @request POST:/api/v1/auth/user_password_reset/start
         */
        userPasswordResetStartApiV1AuthUserPasswordResetStartPost: (
            query: UserPasswordResetStartApiV1AuthUserPasswordResetStartPostParams,
            data: UserPasswordResetModel,
            params: RequestParams = {},
        ) =>
            this.request<UserPasswordResetStartServiceOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/user_password_reset/start`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserPasswordResetGetTokenApiV1AuthUserPasswordResetGetTokenPost
         * @summary User Password Reset Get Token
         * @request POST:/api/v1/auth/user_password_reset/get_token
         */
        userPasswordResetGetTokenApiV1AuthUserPasswordResetGetTokenPost: (
            query: UserPasswordResetGetTokenApiV1AuthUserPasswordResetGetTokenPostParams,
            data: UserPasswordResetGetTokenModel,
            params: RequestParams = {},
        ) =>
            this.request<UserPasswordResetGetTokenServiceOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/user_password_reset/get_token`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name UserPasswordResetCompleteApiV1AuthUserPasswordResetCompletePost
         * @summary User Password Reset Complete
         * @request POST:/api/v1/auth/user_password_reset/complete
         */
        userPasswordResetCompleteApiV1AuthUserPasswordResetCompletePost: (
            query: UserPasswordResetCompleteApiV1AuthUserPasswordResetCompletePostParams,
            data: UserPasswordResetCompleteModel,
            params: RequestParams = {},
        ) =>
            this.request<UserPasswordResetCompleteServiceOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/user_password_reset/complete`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name GetTokenBySecurityTokenApiV1AuthGetTokenBySecurityTokenPost
         * @summary Get Token By Security Token
         * @request POST:/api/v1/auth/get_token_by_security_token
         */
        getTokenBySecurityTokenApiV1AuthGetTokenBySecurityTokenPost: (
            query: GetTokenBySecurityTokenApiV1AuthGetTokenBySecurityTokenPostParams,
            data: GetTokenBySecurityTokenModel,
            params: RequestParams = {},
        ) =>
            this.request<GetTokenBySecurityTokenOutputDTO, HTTPValidationError>({
                path: `/api/v1/auth/get_token_by_security_token`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name GetUserByTokenApiV1AuthInnerUserByTokenPost
         * @summary Get User By Token
         * @request POST:/api/v1/auth_inner/user_by_token
         */
        getUserByTokenApiV1AuthInnerUserByTokenPost: (
            query: GetUserByTokenApiV1AuthInnerUserByTokenPostParams,
            data: GetUserByTokenModel,
            params: RequestParams = {},
        ) =>
            this.request<UserShortDTO, HTTPValidationError>({
                path: `/api/v1/auth_inner/user_by_token`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name GetUserBySubApiV1AuthInnerUserByUserinfoPost
         * @summary Get User By Sub
         * @request POST:/api/v1/auth_inner/user_by_userinfo
         */
        getUserBySubApiV1AuthInnerUserByUserinfoPost: (
            query: GetUserBySubApiV1AuthInnerUserByUserinfoPostParams,
            data: GetUserByUserinfoModel,
            params: RequestParams = {},
        ) =>
            this.request<AuthenticatedUserDTO, HTTPValidationError>({
                path: `/api/v1/auth_inner/user_by_userinfo`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Authorization
         * @name EmailVerifyResendCodeApiV1EmailVerifyResendCodePost
         * @summary Email Verify Resend Code
         * @request POST:/api/v1/email_verify/resend_code
         */
        emailVerifyResendCodeApiV1EmailVerifyResendCodePost: (
            query: EmailVerifyResendCodeApiV1EmailVerifyResendCodePostParams,
            data: EmailVerifyResendModel,
            params: RequestParams = {},
        ) =>
            this.request<EmailVerifyResendCodeOutputDTO, HTTPValidationError>({
                path: `/api/v1/email_verify/resend_code`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Balance
         * @name CreateDepositApiV1DepositPost
         * @summary Create Deposit
         * @request POST:/api/v1/deposit
         */
        createDepositApiV1DepositPost: (
            query: CreateDepositApiV1DepositPostParams,
            data: WIDepositCreateModel,
            params: RequestParams = {},
        ) =>
            this.request<DepositCreateOutputDTO, HTTPValidationError>({
                path: `/api/v1/deposit`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Recurring Payment
         * @name GetRecurringPaymentApiV1RecurringPaymentGet
         * @summary Get Recurring Payment
         * @request GET:/api/v1/recurring_payment
         */
        getRecurringPaymentApiV1RecurringPaymentGet: (
            query: GetRecurringPaymentApiV1RecurringPaymentGetParams,
            params: RequestParams = {},
        ) =>
            this.request<RecurringPaymentDetailOutputDTO, HTTPValidationError>({
                path: `/api/v1/recurring_payment`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Recurring Payment
         * @name PatchRecurringPaymentApiV1RecurringPaymentPatch
         * @summary Patch Recurring Payment
         * @request PATCH:/api/v1/recurring_payment
         */
        patchRecurringPaymentApiV1RecurringPaymentPatch: (
            query: PatchRecurringPaymentApiV1RecurringPaymentPatchParams,
            data: RecurringPaymentUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<RecurringPaymentDetailOutputDTO, HTTPValidationError>({
                path: `/api/v1/recurring_payment`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Recurring Payment
         * @name PostRecurringPaymentApiV1RecurringPaymentPost
         * @summary Post Recurring Payment
         * @request POST:/api/v1/recurring_payment
         */
        postRecurringPaymentApiV1RecurringPaymentPost: (
            query: PostRecurringPaymentApiV1RecurringPaymentPostParams,
            data: RecurringPaymentUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<DepositCreateOutputDTO, HTTPValidationError>({
                path: `/api/v1/recurring_payment`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Balance
         * @name BalanceIncreaseListApiV1BillingBalanceIncreaseGet
         * @summary Balance Increase List
         * @request GET:/api/v1/billing/balance_increase
         */
        balanceIncreaseListApiV1BillingBalanceIncreaseGet: (
            query: BalanceIncreaseListApiV1BillingBalanceIncreaseGetParams,
            params: RequestParams = {},
        ) =>
            this.request<BalanceIncreaseOutputDTO, HTTPValidationError>({
                path: `/api/v1/billing/balance_increase`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Balance
         * @name ServiceChargeListApiV1BillingServiceChargeGet
         * @summary Service Charge List
         * @request GET:/api/v1/billing/service_charge
         */
        serviceChargeListApiV1BillingServiceChargeGet: (
            query: ServiceChargeListApiV1BillingServiceChargeGetParams,
            params: RequestParams = {},
        ) =>
            this.request<ServiceChargeOutputDTO, HTTPValidationError>({
                path: `/api/v1/billing/service_charge`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notification
         * @name CallbackHandleApiV1NotificationsPspSlugPost
         * @summary Callback Handle
         * @request POST:/api/v1/notifications/{psp_slug}
         */
        callbackHandleApiV1NotificationsPspSlugPost: (
            pspSlug: string,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/notifications/${pspSlug}`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Wallet
         * @name UserWalletGetApiV1WalletGet
         * @summary User Wallet Get
         * @request GET:/api/v1/wallet
         */
        userWalletGetApiV1WalletGet: (
            query: UserWalletGetApiV1WalletGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserWalletDTO, HTTPValidationError>({
                path: `/api/v1/wallet`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Promocode
         * @name ApplyPromocodeApiV1PromocodeApplyPost
         * @summary Apply Promocode
         * @request POST:/api/v1/promocode/apply
         */
        applyPromocodeApiV1PromocodeApplyPost: (
            query: ApplyPromocodeApiV1PromocodeApplyPostParams,
            data: ApplyPromocodeModel,
            params: RequestParams = {},
        ) =>
            this.request<AppliedPromocodeDTO, HTTPValidationError>({
                path: `/api/v1/promocode/apply`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UserGetApiV1UserGet
         * @summary User Get
         * @request GET:/api/v1/user
         */
        userGetApiV1UserGet: (query: UserGetApiV1UserGetParams, params: RequestParams = {}) =>
            this.request<UserInfoModel, HTTPValidationError>({
                path: `/api/v1/user`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UserUpdateApiV1UserPatch
         * @summary User Update
         * @request PATCH:/api/v1/user
         */
        userUpdateApiV1UserPatch: (
            query: UserUpdateApiV1UserPatchParams,
            data: UserInfoUpdateModel,
            params: RequestParams = {},
        ) =>
            this.request<UserInfoModel, HTTPValidationError>({
                path: `/api/v1/user`,
                method: 'PATCH',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User
         * @name UserDeleteApiV1UserDeletePost
         * @summary User Delete
         * @request POST:/api/v1/user/delete
         */
        userDeleteApiV1UserDeletePost: (
            query: UserDeleteApiV1UserDeletePostParams,
            data: UserDeleteModel,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/user/delete`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tariff
         * @name TariffDetailApiV1TariffTariffUuidGet
         * @summary Tariff Detail
         * @request GET:/api/v1/tariff/{tariff_uuid}
         */
        tariffDetailApiV1TariffTariffUuidGet: (
            { tariffUuid, ...query }: TariffDetailApiV1TariffTariffUuidGetParams,
            params: RequestParams = {},
        ) =>
            this.request<TariffDTO, HTTPValidationError>({
                path: `/api/v1/tariff/${tariffUuid}`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Tariff
         * @name TariffListApiV1TariffGet
         * @summary Tariff List
         * @request GET:/api/v1/tariff
         */
        tariffListApiV1TariffGet: (
            query: TariffListApiV1TariffGetParams,
            params: RequestParams = {},
        ) =>
            this.request<TariffListOutputDTO, HTTPValidationError>({
                path: `/api/v1/tariff`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User tariff
         * @name UserTariffActivateApiV1UserTariffActivatePost
         * @summary User Tariff Activate
         * @request POST:/api/v1/user_tariff/activate
         */
        userTariffActivateApiV1UserTariffActivatePost: (
            query: UserTariffActivateApiV1UserTariffActivatePostParams,
            data: UserTariffActivateInputModel,
            params: RequestParams = {},
        ) =>
            this.request<UserTariffDTO, HTTPValidationError>({
                path: `/api/v1/user_tariff/activate`,
                method: 'POST',
                query: query,
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User tariff
         * @name UserTariffActiveApiV1UserTariffGet
         * @summary User Tariff Active
         * @request GET:/api/v1/user_tariff
         */
        userTariffActiveApiV1UserTariffGet: (
            query: UserTariffActiveApiV1UserTariffGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserTariffDTO, HTTPValidationError>({
                path: `/api/v1/user_tariff`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User referral
         * @name UserReferralApiV1UserReferralInfoGet
         * @summary User Referral
         * @request GET:/api/v1/user_referral/info
         */
        userReferralApiV1UserReferralInfoGet: (
            query: UserReferralApiV1UserReferralInfoGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserReferralInfoDTO, HTTPValidationError>({
                path: `/api/v1/user_referral/info`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags User referral
         * @name UserReferralListApiV1UserReferralGet
         * @summary User Referral List
         * @request GET:/api/v1/user_referral
         */
        userReferralListApiV1UserReferralGet: (
            query: UserReferralListApiV1UserReferralGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserReferralBalanceIncreaseListOutputDTO, HTTPValidationError>({
                path: `/api/v1/user_referral`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications settings
         * @name UserNotificationsInfoApiV1NotificationsSettingsGet
         * @summary User Notifications Info
         * @request GET:/api/v1/notifications_settings
         */
        userNotificationsInfoApiV1NotificationsSettingsGet: (params: RequestParams = {}) =>
            this.request<UserNotificationsSettingsDTO, HTTPValidationError>({
                path: `/api/v1/notifications_settings`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications settings
         * @name UserNotificationsCreateApiV1NotificationsSettingsPost
         * @summary User Notifications Create
         * @request POST:/api/v1/notifications_settings
         */
        userNotificationsCreateApiV1NotificationsSettingsPost: (
            data: UserNotificationsModel,
            params: RequestParams = {},
        ) =>
            this.request<UserNotificationsSettingsDTO, HTTPValidationError>({
                path: `/api/v1/notifications_settings`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications settings
         * @name UserNotificationsUpdateApiV1NotificationsSettingsPatch
         * @summary User Notifications Update
         * @request PATCH:/api/v1/notifications_settings
         */
        userNotificationsUpdateApiV1NotificationsSettingsPatch: (
            data: UserNotificationsModel,
            params: RequestParams = {},
        ) =>
            this.request<UserNotificationsSettingsDTO, HTTPValidationError>({
                path: `/api/v1/notifications_settings`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WebPush notifications
         * @name GetUserListApiV1WebpushNotificationsListGet
         * @summary Get User List
         * @request GET:/api/v1/webpush_notifications/list/
         */
        getUserListApiV1WebpushNotificationsListGet: (params: RequestParams = {}) =>
            this.request<WebPushSubscription[], HTTPValidationError>({
                path: `/api/v1/webpush_notifications/list/`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WebPush notifications
         * @name SubscribeApiV1WebpushNotificationsSubscribePost
         * @summary Subscribe
         * @request POST:/api/v1/webpush_notifications/subscribe
         */
        subscribeApiV1WebpushNotificationsSubscribePost: (
            data: NewWebPushSubscription,
            params: RequestParams = {},
        ) =>
            this.request<WebPushSubscription, HTTPValidationError>({
                path: `/api/v1/webpush_notifications/subscribe`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WebPush notifications
         * @name UnsubscribeApiV1WebpushNotificationsUnsubscribePatch
         * @summary Unsubscribe
         * @request PATCH:/api/v1/webpush_notifications/unsubscribe
         */
        unsubscribeApiV1WebpushNotificationsUnsubscribePatch: (
            data: UnsubscribeBody,
            params: RequestParams = {},
        ) =>
            this.request<WebPushSubscription, HTTPValidationError>({
                path: `/api/v1/webpush_notifications/unsubscribe`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WebPush notifications
         * @name UnsubscribeAllApiV1WebpushNotificationsUnsubscribeAllPatch
         * @summary Unsubscribe All
         * @request PATCH:/api/v1/webpush_notifications/unsubscribe_all
         */
        unsubscribeAllApiV1WebpushNotificationsUnsubscribeAllPatch: (params: RequestParams = {}) =>
            this.request<WebPushSubscription[], HTTPValidationError>({
                path: `/api/v1/webpush_notifications/unsubscribe_all`,
                method: 'PATCH',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags WebPush notifications
         * @name SendApiV1WebpushNotificationsSendPost
         * @summary Send
         * @request POST:/api/v1/webpush_notifications/send
         */
        sendApiV1WebpushNotificationsSendPost: (data: PushPayload, params: RequestParams = {}) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/webpush_notifications/send`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed event
         * @name CreateApiV1NotificationsFeedEventPost
         * @summary Create
         * @request POST:/api/v1/notifications_feed_event
         */
        createApiV1NotificationsFeedEventPost: (
            data: NotificationEventCreate,
            params: RequestParams = {},
        ) =>
            this.request<NotificationEvent, HTTPValidationError>({
                path: `/api/v1/notifications_feed_event`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed event
         * @name UpdateApiV1NotificationsFeedEventPut
         * @summary Update
         * @request PUT:/api/v1/notifications_feed_event
         */
        updateApiV1NotificationsFeedEventPut: (
            data: NotificationEventUpdate,
            params: RequestParams = {},
        ) =>
            this.request<NotificationEvent, HTTPValidationError>({
                path: `/api/v1/notifications_feed_event`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed event
         * @name DeleteApiV1NotificationsFeedEventCodeDelete
         * @summary Delete
         * @request DELETE:/api/v1/notifications_feed_event/{code}
         */
        deleteApiV1NotificationsFeedEventCodeDelete: (code: string, params: RequestParams = {}) =>
            this.request<NotificationEvent, HTTPValidationError>({
                path: `/api/v1/notifications_feed_event/${code}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed event
         * @name GetApiV1NotificationsFeedEventCodeGet
         * @summary Get
         * @request GET:/api/v1/notifications_feed_event/{code}
         */
        getApiV1NotificationsFeedEventCodeGet: (code: string, params: RequestParams = {}) =>
            this.request<NotificationEvent, HTTPValidationError>({
                path: `/api/v1/notifications_feed_event/${code}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed event
         * @name GetListApiV1NotificationsFeedEventListGet
         * @summary Get List
         * @request GET:/api/v1/notifications_feed_event/list/
         */
        getListApiV1NotificationsFeedEventListGet: (
            query: GetListApiV1NotificationsFeedEventListGetParams,
            params: RequestParams = {},
        ) =>
            this.request<NotificationEventGetList, HTTPValidationError>({
                path: `/api/v1/notifications_feed_event/list/`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name SetSettingsApiV1NotificationsFeedUserEventSettingsPatch
         * @summary Set Settings
         * @request PATCH:/api/v1/notifications_feed_user_event/settings
         */
        setSettingsApiV1NotificationsFeedUserEventSettingsPatch: (
            data: UserFeedSettings,
            params: RequestParams = {},
        ) =>
            this.request<UserFeedSettings, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/settings`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name SendAllApiV1NotificationsFeedUserEventSendToAllPost
         * @summary Send All
         * @request POST:/api/v1/notifications_feed_user_event/send_to_all
         */
        sendAllApiV1NotificationsFeedUserEventSendToAllPost: (
            data: AllUserNotificationCreate,
            params: RequestParams = {},
        ) =>
            this.request<any, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/send_to_all`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name CreateApiV1NotificationsFeedUserEventPost
         * @summary Create
         * @request POST:/api/v1/notifications_feed_user_event
         */
        createApiV1NotificationsFeedUserEventPost: (
            data: UserNotificationCreateWithoutUser,
            params: RequestParams = {},
        ) =>
            this.request<UserNotification, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name UpdateApiV1NotificationsFeedUserEventPut
         * @summary Update
         * @request PUT:/api/v1/notifications_feed_user_event
         */
        updateApiV1NotificationsFeedUserEventPut: (
            data: UserNotificationUpdate,
            params: RequestParams = {},
        ) =>
            this.request<UserNotification, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name ReadApiV1NotificationsFeedUserEventReadIdxPatch
         * @summary Read
         * @request PATCH:/api/v1/notifications_feed_user_event/read/{idx}
         */
        readApiV1NotificationsFeedUserEventReadIdxPatch: (
            { idx, ...query }: ReadApiV1NotificationsFeedUserEventReadIdxPatchParams,
            params: RequestParams = {},
        ) =>
            this.request<UserNotification, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/read/${idx}`,
                method: 'PATCH',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name ReadAllApiV1NotificationsFeedUserEventReadAllPatch
         * @summary Read All
         * @request PATCH:/api/v1/notifications_feed_user_event/read_all
         */
        readAllApiV1NotificationsFeedUserEventReadAllPatch: (params: RequestParams = {}) =>
            this.request<UserNotificationTotalCount, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/read_all`,
                method: 'PATCH',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name GetApiV1NotificationsFeedUserEventIdxGet
         * @summary Get
         * @request GET:/api/v1/notifications_feed_user_event/{idx}
         */
        getApiV1NotificationsFeedUserEventIdxGet: (idx: number, params: RequestParams = {}) =>
            this.request<UserNotification, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/${idx}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name GetListApiV1NotificationsFeedUserEventListGet
         * @summary Get List
         * @request GET:/api/v1/notifications_feed_user_event/list/
         */
        getListApiV1NotificationsFeedUserEventListGet: (
            query: GetListApiV1NotificationsFeedUserEventListGetParams,
            params: RequestParams = {},
        ) =>
            this.request<UserNotificationGetList, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/list/`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Notifications feed user event
         * @name GetTotalApiV1NotificationsFeedUserEventTotalGet
         * @summary Get Total
         * @request GET:/api/v1/notifications_feed_user_event/total/
         */
        getTotalApiV1NotificationsFeedUserEventTotalGet: (params: RequestParams = {}) =>
            this.request<UserNotificationTotalCount, HTTPValidationError>({
                path: `/api/v1/notifications_feed_user_event/total/`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Storage tariff list
         *
         * @tags Storage tariff
         * @name GetListApiV1StorageTariffGet
         * @summary Get List
         * @request GET:/api/v1/storage_tariff
         */
        getListApiV1StorageTariffGet: (
            query: GetListApiV1StorageTariffGetParams,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffGetList, HTTPValidationError>({
                path: `/api/v1/storage_tariff`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * @description Storage tariff details
         *
         * @tags Storage tariff
         * @name GetApiV1StorageTariffTariffIdGet
         * @summary Get
         * @request GET:/api/v1/storage_tariff/{tariff_id}
         */
        getApiV1StorageTariffTariffIdGet: (tariffId: number, params: RequestParams = {}) =>
            this.request<StorageTariff, HTTPValidationError>({
                path: `/api/v1/storage_tariff/${tariffId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Storage tariff delete
         *
         * @tags Storage tariff
         * @name DeleteApiV1StorageTariffTariffIdDelete
         * @summary Delete
         * @request DELETE:/api/v1/storage_tariff/{tariff_id}
         */
        deleteApiV1StorageTariffTariffIdDelete: (tariffId: number, params: RequestParams = {}) =>
            this.request<StorageTariff, HTTPValidationError>({
                path: `/api/v1/storage_tariff/${tariffId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * @description Get all active storage tariff for user
         *
         * @tags Storage user tariff
         * @name GetAllStorageTariffsUserApiV1StorageTariffUserGet
         * @summary Get All Storage Tariffs User
         * @request GET:/api/v1/storage_tariff_user
         */
        getAllStorageTariffsUserApiV1StorageTariffUserGet: (params: RequestParams = {}) =>
            this.request<StorageTariffUserGetListActiveForUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Create storage tariff for user
         *
         * @tags Storage user tariff
         * @name CreateStorageTariffsUserApiV1StorageTariffUserPost
         * @summary Create Storage Tariffs User
         * @request POST:/api/v1/storage_tariff_user
         */
        createStorageTariffsUserApiV1StorageTariffUserPost: (
            data: StorageTariffUserInputCreate,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description Update storage tariff for user
         *
         * @tags Storage user tariff
         * @name UpdateStorageTariffsUserApiV1StorageTariffUserPut
         * @summary Update Storage Tariffs User
         * @request PUT:/api/v1/storage_tariff_user
         */
        updateStorageTariffsUserApiV1StorageTariffUserPut: (
            data: StorageTariffUserInputUpdate,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user`,
                method: 'PUT',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description Update storage tariff for user
         *
         * @tags Storage user tariff
         * @name UpdateAutoRenewStorageTariffsUserApiV1StorageTariffUserPatch
         * @summary Update Auto Renew Storage Tariffs User
         * @request PATCH:/api/v1/storage_tariff_user
         */
        updateAutoRenewStorageTariffsUserApiV1StorageTariffUserPatch: (
            data: StorageTariffUserInputUpdate,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user`,
                method: 'PATCH',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * @description Get available storage for user in bytes
         *
         * @tags Storage user tariff
         * @name GetAvailableStorageApiV1StorageTariffUserAvailableStorageGet
         * @summary Get Available Storage
         * @request GET:/api/v1/storage_tariff_user/available_storage
         */
        getAvailableStorageApiV1StorageTariffUserAvailableStorageGet: (
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUserAvailableStorage, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user/available_storage`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Deactivate auto renew storage tariff for user
         *
         * @tags Storage user tariff
         * @name DeleteStorageTariffsUserApiV1StorageTariffUserStorageTariffUserIdDelete
         * @summary Delete Storage Tariffs User
         * @request DELETE:/api/v1/storage_tariff_user/{storage_tariff_user_id}
         */
        deleteStorageTariffsUserApiV1StorageTariffUserStorageTariffUserIdDelete: (
            storageTariffUserId: number,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user/${storageTariffUserId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * @description Get storage tariff for user
         *
         * @tags Storage user tariff
         * @name GetStorageTariffsUserApiV1StorageTariffUserStorageTariffUserIdGet
         * @summary Get Storage Tariffs User
         * @request GET:/api/v1/storage_tariff_user/{storage_tariff_user_id}
         */
        getStorageTariffsUserApiV1StorageTariffUserStorageTariffUserIdGet: (
            storageTariffUserId: number,
            params: RequestParams = {},
        ) =>
            this.request<StorageTariffUser, HTTPValidationError>({
                path: `/api/v1/storage_tariff_user/${storageTariffUserId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Get all assistant subscriptions
         *
         * @tags Paid assistant
         * @name GetAllAssistantSubscriptionsApiV1PaidAssistantGet
         * @summary Get All Assistant Subscriptions
         * @request GET:/api/v1/paid_assistant
         */
        getAllAssistantSubscriptionsApiV1PaidAssistantGet: (params: RequestParams = {}) =>
            this.request<PaidAssistantListForGetUser, HTTPValidationError>({
                path: `/api/v1/paid_assistant`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * @description Set autorenew as true
         *
         * @tags Paid assistant
         * @name ResumeAutoRenewApiV1PaidAssistantUserSubscriptionIdPatch
         * @summary Resume Auto Renew
         * @request PATCH:/api/v1/paid_assistant/{user_subscription_id}
         */
        resumeAutoRenewApiV1PaidAssistantUserSubscriptionIdPatch: (
            userSubscriptionId: number,
            params: RequestParams = {},
        ) =>
            this.request<AssistantSubscription | AssistantFreePeriod, HTTPValidationError>({
                path: `/api/v1/paid_assistant/${userSubscriptionId}`,
                method: 'PATCH',
                format: 'json',
                ...params,
            }),

        /**
         * @description Set autorenew as false
         *
         * @tags Paid assistant
         * @name StopAutoRenewApiV1PaidAssistantUserSubscriptionIdDelete
         * @summary Stop Auto Renew
         * @request DELETE:/api/v1/paid_assistant/{user_subscription_id}
         */
        stopAutoRenewApiV1PaidAssistantUserSubscriptionIdDelete: (
            userSubscriptionId: number,
            params: RequestParams = {},
        ) =>
            this.request<AssistantSubscription | AssistantFreePeriod, HTTPValidationError>({
                path: `/api/v1/paid_assistant/${userSubscriptionId}`,
                method: 'DELETE',
                format: 'json',
                ...params,
            }),

        /**
         * @description Create subscription for assistant
         *
         * @tags Paid assistant
         * @name PaidAssistantSubscribeApiV1PaidAssistantAssistantIdPost
         * @summary Paid Assistant Subscribe
         * @request POST:/api/v1/paid_assistant/{assistant_id}
         */
        paidAssistantSubscribeApiV1PaidAssistantAssistantIdPost: (
            assistantId: number,
            params: RequestParams = {},
        ) =>
            this.request<AssistantSubscription | AssistantFreePeriod, HTTPValidationError>({
                path: `/api/v1/paid_assistant/${assistantId}`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * @description Check availability of free period for assistant
         *
         * @tags Paid assistant
         * @name PaidAssistantAvailableApiV1PaidAssistantFreeAssistantIdGet
         * @summary Paid Assistant Available
         * @request GET:/api/v1/paid_assistant/free/{assistant_id}
         */
        paidAssistantAvailableApiV1PaidAssistantFreeAssistantIdGet: (
            assistantId: number,
            params: RequestParams = {},
        ) =>
            this.request<AssistantFreePeriodUserInfoIsAvailable, HTTPValidationError>({
                path: `/api/v1/paid_assistant/free/${assistantId}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Mobile push
         * @name CreateMobilePushApiV1MobilePushPost
         * @summary Create Mobile Push
         * @request POST:/api/v1/mobile_push
         */
        createMobilePushApiV1MobilePushPost: (
            data: MobilePushCreateInput,
            params: RequestParams = {},
        ) =>
            this.request<MobilePush, HTTPValidationError>({
                path: `/api/v1/mobile_push`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags Mobile push
         * @name ToAllMobilePushApiV1MobilePushToAllPost
         * @summary To All Mobile Push
         * @request POST:/api/v1/mobile_push/to_all
         */
        toAllMobilePushApiV1MobilePushToAllPost: (
            data: PushMessageInput,
            params: RequestParams = {},
        ) =>
            this.request<PushMessageTotalCount, HTTPValidationError>({
                path: `/api/v1/mobile_push/to_all`,
                method: 'POST',
                body: data,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),
    }
}
